// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
| EzClocker Containers/Boxes UX CSS Classes
| CSS variables defined in: /src/main/webapp/public/styles/common/ez-body.css
~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */
.ezContainer {
  padding: 0;
  background-color: transparent;
  border-color: transparent;
}

.ezContainer-width-100 {
  width: 100%;
}

.ez-debug-timezone-container {
  position: absolute;
  padding: 2px;
  left: 10px;
  top: 0;
  background-color: var(--ezClockerBabyBlue);
  color: var(--ezClockerGray);
  font-size: xx-small;
  font-style: italic;
}

.ezInstructionContainer {
  border-style: none;
  padding: 8px;
  background-color: var(--ezClockerWhite);
  color: var(--ezClockerBlack);
}

/* Input Containers/Boxes */
.ezContainer-date-picker {
  display: grid;
  grid-template-columns: auto;
  grid-template-rows: auto auto;
  grid-row-gap: 4px;
  grid-column-gap: 4px;
  justify-content: stretch;
  align-content: top;
  padding: 0;
  margin: 0;
  background-color: transparent;
  color: var(--ezClockerBlack);
  border-style: none;
}

.ezContainer-labeled-input-vertical {
  display: grid;
  grid-template-columns: 100%;
  grid-template-rows: auto auto;
  grid-row-gap: 4px;
  grid-column-gap: 0;
  justify-content: stretch;
  align-content: center;
  margin-top: 8px;
  margin-bottom: 8px;
  background-color: transparent;
  color: var(--ezClockerBlack);
  border-style: none;
}

.ezInputContainer {
  border-style: none;
  padding: 8px;
  background-color: var(--ezClockerSilver);
  color: var(--ezClockerBlack);
}

.ezTransparentInputContainer {
  padding: 8px;
  background-color: transparent;
  color: var(--ezFontColor);
  border-style: none;
}

/* DEPRECATED: Switch to ezInputs-input-box */
.ezInputBox {
  display: grid;
  grid-template-columns: 100%;
  grid-template-rows: auto auto;
  justify-content: start;
  align-content: center;
  padding: 4px;
  background-color: transparent;
  color: var(--ezFontColor);
}

.ezContainers_InputBox {
  display: grid;
  padding: 4px;
  grid-template-columns: 100%;
  grid-template-rows: auto auto;
  justify-content: start;
  align-content: center;
  background-color: transparent;
  color: var(--ezFontColor);
}

.ezContaner_CenterInputBox {
  display: grid;
  grid-template-columns: 100%;
  grid-template-rows: auto auto;
  justify-content: stretch;
  align-content: center;
  padding: 4px;
  background-color: transparent;
  color: var(--ezFontColor);
}

.ezCenterInputBox {
  display: grid;
  grid-template-columns: auto;
  grid-template-rows: auto auto;
  justify-content: center;
  align-content: center;
  padding: 4px;
  background-color: transparent;
  color: var(--ezFontColor);
}

.ezLargeInputBox,
.ezContainers-large-input-box {
  display: grid;
  padding: 8px;
  grid-template-columns: auto;
  grid-template-rows: auto auto;
}

.ezSmallInputBox,
.ezContainers-small-input-box {
  margin-top: 4px;
  margin-bottom: 4px;
}

.ezErrorContainer {
  margin: 4px;
  padding: 4px;
  min-height: 20px;
  min-width: 20px;
  background-color: var(--ezLightAlertRed);
  background-size: 20px 20px;
  background-repeat: no-repeat;
  background-position: 4px 4px;
  color: var(--ezClockerBlack);
  font-size: 12pt;
  border-color: var(--ezBorderAlertRed);
  border-style: solid;
  border-width: 1px;
}

.ezErrorBox {
  margin-top: 4px;
  margin-bottom: 4px;
  padding-top: 4px;
  padding-right: 4px;
  padding-bottom: 4px;
  padding-left: 28px;
  min-height: 20px;
  min-width: 20px;
  background-color: var(--ezClockerErrorRed);
  background-image: url("/public/images/icons/error-red.svg");
  background-size: 20px 20px;
  background-repeat: no-repeat;
  background-position-x: 4px;
  background-position-y: center;
  color: var(--ezClockerBlack);
  font-size: 12pt;
  border-style: solid;
  border-width: 1px;
  border-color: var(--ezBorderAlertRed);
  border-radius: 3px;
}

.ezContainer-validation-error-box {
  margin-top: 4px;
  margin-bottom: 4px;
  padding-top: 4px;
  padding-right: 4px;
  padding-bottom: 4px;
  padding-left: 28px;
  min-height: 17px;
  min-width: 17px;
  background-color: var(--ezClockerErrorRed);
  background-image: url("/public/images/icons/error-red.svg");
  background-size: 17px 17px;
  background-repeat: no-repeat;
  background-position-x: 4px;
  background-position-y: center;
  color: var(--ezClockerBlack);
  font-size: 12pt;
  border-style: solid;
  border-width: 1px;
  border-color: var(--ezBorderAlertRed);
  border-radius: 3px;
}

.ezWarningBox {
  margin-top: 4px;
  margin-bottom: 4px;
  padding-top: 4px;
  padding-right: 4px;
  padding-bottom: 4px;
  padding-left: 28px;
  min-height: 20px;
  min-width: 20px;
  background-color: var(--ezLightWarningYellow);
  background-image: url("/public/images/icons/warn-triangle-yellow.svg");
  background-size: 20px 20px;
  background-repeat: no-repeat;
  background-position: left;
  color: var(--ezClockerBlack);
  font-size: 12pt;
  border-style: solid;
  border-width: 1px;
  border-color: var(--ezBorderWarningYellow);
  border-radius: 3px;
}

.ezContainer-warning-no-image {
  margin-top: 8px;
  margin-bottom: 8px;
  padding: 8px;
  min-height: 24px;
  background-color: var(--ezLightWarningYellow);
  color: var(--ezClockerBlack);
  font-size: 12pt;
  border-color: var(--ezBorderWarningYellow);
  border-style: solid;
  border-radius: 3px;
  border-width: 1px;
}

.ezContainer-warning-no-image-thick-dark-alert-red-border {
  margin-bottom: 8px;
  padding: 8px;
  min-height: 24px;
  background-color: var(--ezLightWarningYellow);
  color: var(--ezClockerBlack);
  font-size: 12pt;
  border-color: var(--ezBorderAlertRed);
  border-style: solid;
  border-radius: 3px;
  border-width: 3px;
}

.ez-floating-error-container {
  position: absolute;
  margin-top: 4px;
  margin-bottom: 4px;
  padding-top: 4px;
  padding-right: 4px;
  padding-bottom: 4px;
  padding-left: 28px;
  background-color: var(--ezClockerErrorRed);
  background-image: url("/public/images/icons/error-red.svg");
  background-size: 20px 20px;
  background-repeat: no-repeat;
  background-position: left;
  color: var(--ezClockerBlack);
  font-size: 12pt;
  border-style: solid;
  border-width: 1px;
  border-color: var(--ezBorderAlertRed);
}

.ezCenterContainer {
  margin: 0;
  padding: 4px;
  text-align: center;
}

/* ezClocker Boxes */
div.ezQuickStatusBox {
  position: fixed;
  display: none;
  z-index: 999;
  background-color: rgb(128 128 128/40%);
  font-size: 8pt;
  color: var(--ezClockerBlack);
  border-style: solid;
  border-width: 2px;
  border-color: var(--ezBorderBabyBlue);
  box-shadow: 0 0 2px 2px rgb(0 0 0/40%);
  padding: 2px;
  margin: 4px;
}

.ezBabyBlueBox {
  padding: 4px;
  background-color: var(--ezClockerBabyBlue);
  color: var(--ezClockerBlack);
  font-family: var(--ezFontFamily);
  font-size: var(--ezFontSize);
  font-weight: var(--ezFontWeight);
  border-style: solid;
  border-color: var(--ezBorderBabyBlue);
  border-width: 1px;
  border-radius: 3px;
}

.ezContentsBox {
  display: inline-block;
}

.ezBlackBox {
  padding: 4px;
  color: var(--ezClockerWhite);
  background-color: var(--ezClockerBlack);
  border-color: var(--ezClockerBlack);
  border-style: solid;
  border-width: 1px;
  border-radius: 3px;
}

.ezBlackBox8 {
  padding: 8px;
  color: var(--ezClockerWhite);
  background-color: var(--ezClockerBlack);
  border-color: var(--ezClockerBlack);
  border-style: solid;
  border-width: 1px;
  border-radius: 3px;
}

.ezSilverBox {
  padding: 4px;
  color: var(--ezClockerBlack);
  background-color: var(--ezClockerSilver);
  border-color: #a7a9ab;
  border-style: solid;
  border-width: 1px;
  border-radius: 3px;
}

.ezSilverBox8 {
  padding: 8px;
  color: var(--ezClockerBlack);
  background-color: var(--ezClockerSilver);
  border-color: #a7a9ab;
  border-style: solid;
  border-width: 1px;
  border-radius: 3px;
}

.ezContainer-ezClockerYellow-pad-4 {
  padding: 8px;
  background-color: var(--ezClockerYellow);
  color: var(--ezClockerBlack);
  border-color: var(--ezBorderYellow);
  border-style: solid;
  border-width: 1px;
  border-radius: 3px;
}

/*
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    ezClockerWhite containers
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Active
        ezContainer-ezClockerWhite-pad-4
        ezContainer-ezClockerWhite-pad-8
        ezContainer-ezClockerWhite-pad-10
        ezContainer-bottom-ezClockerWhite-pad-10
        ezContainer-ezClockerWhite-shadow
        ezContainer-default-ezClockerWhite
        ezContainers-ezClockerWhite-small-help
        (DEPRECATED) ezWhiteBox
        (DEPRECATED) ezWhiteBox8
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
*/
.ezContainer-ezClockerWhite-pad-4,
.ezWhiteBox {
  padding: 4px;
  color: var(--ezClockerBlack);
  background-color: var(--ezClockerWhite);
  border-color: var(--ezClockerGray);
  border-style: solid;
  border-width: 1px;
  border-radius: 3px;
}

.ezContainer-ezClockerWhite-pad-4-no-border {
  padding: 4px;
  color: var(--ezClockerBlack);
  background-color: var(--ezClockerWhite);
  border-style: none;
}

.ezContainer-ezClockerWhite-pad-8,
.ezWhiteBox8 {
  padding: 8px;
  color: var(--ezClockerBlack);
  background-color: var(--ezClockerWhite);
  border-color: var(--ezClockerGray);
  border-style: solid;
  border-width: 1px;
  border-radius: 3px;
}

.ezContainer-ezClockerWhite-pad-10 {
  padding: 10px;
  background-color: var(--ezClockerWhite);
  color: var(--ezClockerBlack);
  border-color: var(--ezClockerGray);
  border-style: solid;
  border-width: 1px;
  border-radius: 3px;
}

.ezContainer-bottom-ezClockerWhite-pad-10 {
  padding: 10px;
  color: var(--ezClockerBlack);
  background-color: var(--ezClockerWhite);
  border-color: var(--ezClockerGray);
  border-style: solid;
  border-width: 1px;
  border-radius: 0 0 3px 3px;
}

.ezContainer-default-ezClockerWhite {
  background-color: var(--ezClockerWhite);
  border-style: none;
}

.ezContainer-ezClockerWhite-shadow {
  background-color: var(--ezClockerWhite);
  border-style: none;
  box-shadow: 4px 4px 8px -2px var(--ezClockerGray);
}

.ezContainers-ezClockerWhite-small-content {
  padding: 4px;
  background-color: var(--ezClockerWhite);
  color: var(--ezClockerBlack);
  font-size: var(--ezSmallFontSize);
}

.ezContainers-ezMobileBlue-pad2 {
  padding: 2px;
  color: var(--ezClockerWhite);
  background-color: var(--ezClockerMobileBlue);
  border-color: var(--ezClockerGray);
  border-style: solid;
  border-width: 2px;
}

/*
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    ezClockerSilver containers
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Active
        ezContainer-ezClockerSilver-pad-8
        ezContainer-ezClockerSilver-pad-10
        ezContainer-bottom-ezClockerSilver-pad-10
        ezContainer-ezClockerSilver-shadow
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
*/
.ezContainer-ezClockerSilver-pad-4 {
  padding: 4px;
  background-color: var(--ezClockerSilver);
  color: var(--ezClockerBlack);
  border-color: var(--ezClockerGray);
  border-style: solid;
  border-width: 1px;
  border-radius: 3px;
}

.ezContainer-ezClockerSilver-pad-8 {
  padding: 8px;
  background-color: var(--ezClockerSilver);
  color: var(--ezClockerBlack);
  border-color: var(--ezClockerGray);
  border-style: solid;
  border-width: 1px;
  border-radius: 3px;
}

.ezContainer-ezClockerSilver-pad-10 {
  padding: 10px;
  background-color: var(--ezClockerSilver);
  color: var(--ezClockerBlack);
  border-color: var(--ezClockerGray);
  border-style: solid;
  border-width: 1px;
  border-radius: 3px;
}

.ezContainer-bottom-ezClockerSilver-pad-10 {
  padding: 10px;
  background-color: var(--ezClockerSilver);
  color: var(--ezClockerBlack);
  border-color: var(--ezClockerGray);
  border-style: solid;
  border-width: 1px;
  border-radius: 0 0 3px 3px;
}

.ezContainer-ezClockerSilver-shadow {
  background-color: var(--ezClockerSilver);
  border-style: none;
  box-shadow: 4px 4px 8px -2px var(--ezClockerGray);
}

.ezContainer-ezClockerStone-pad-8 {
  padding: 8px;
  background-color: var(--ezClockerStone);
  color: var(--ezClockerBlack);
  border-color: var(--ezClockerGray);
  border-style: solid;
  border-width: 1px;
  border-radius: 3px;
}

/*
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    ezClockerNavy containers
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Active
        ezContainer-navy4
        ezContainer-navy8
        ezContainer-top-navy4
        ezContainer-top-navy8
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
*/
.ezContainer-navy4 {
  padding: 4px;
  color: var(--ezClockerWhite);
  background-color: var(--ezClockerNavy);
  border-color: var(--ezBorderNavy);
  border-style: solid;
  border-width: 1px;
  border-radius: 3px;
}

.ezContainer-navy8 {
  padding: 8px;
  color: var(--ezClockerWhite);
  background-color: var(--ezClockerNavy);
  border-color: var(--ezBorderNavy);
  border-style: solid;
  border-width: 1px;
  border-radius: 3px;
}

.ezContainer-top-navy4 {
  padding: 4px;
  color: var(--ezClockerWhite);
  background-color: var(--ezClockerNavy);
  border-color: var(--ezBorderNavy);
  border-style: solid;
  border-width: 1px;
  border-top-left-radius: 3px;
  border-top-right-radius: 3px;
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
}

.ezContainer-top-navy8 {
  padding: 8px;
  color: var(--ezClockerWhite);
  background-color: var(--ezClockerNavy);
  border-color: var(--ezBorderNavy);
  border-style: solid;
  border-top-left-radius: 3px;
  border-top-right-radius: 3px;
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
}

.ezContainer-top-gray4 {
  padding: 4px;
  color: var(--ezClockerWhite);
  background-color: var(--ezClockerGray);
  border-color: var(--ezBorderGray);
  border-style: solid;
  border-width: 1px;
  border-top-left-radius: 3px;
  border-top-right-radius: 3px;
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
}

.ez-white-borderless-box8 {
  padding: 8px;
  background-color: var(--ezClockerWhite);
  color: var(--ezClockerBlack);
  border-style: none;
  border-radius: 3px;
}

.ezContainer-white-border-pad8-bottom-margin10 {
  margin-top: 0;
  margin-left: 0;
  margin-right: 0;
  margin-bottom: 10px;
  padding: 8px;
  background-color: var(--ezClockerWhite);
  border-color: var(--ezClockerSilver);
  border-style: solid;
  border-width: 1px;
  border-radius: 3px;
}

.ezContainer-alpha-white-silver-border-8 {
  margin-top: 10px;
  margin-bottom: 10px;
  padding: 8px;
  background-color: rgb(255 255 255/50%);
  border-color: var(--ezClockerSilver);
  border-style: solid;
  border-width: 1px;
  border-radius: 3px;
}

.ezContainer-white-right-aligned-button-container {
  margin-top: 10px;
  margin-bottom: 10px;
  padding: 8px;
  background-color: rgb(255 255 255/50%);
  text-align: right;
  border-color: var(--ezClockerSilver);
  border-style: solid;
  border-width: 1px;
  border-radius: 3px;
}

.ezContainer-transparent-button-bar-no-border {
  display: flex;
  flex-direction: row-reverse;
  margin-top: 10px;
  margin-bottom: 10px;
  padding: 8px;
  background-color: transparent;
}

.ezTransparentBox {
  padding: 4px;
  color: var(--ezClockerBlack);
  background-color: transparent;
  border-color: transparent;
}

.ezTransparentBox8 {
  padding: 8px;
  color: var(--ezClockerBlack);
  background-color: transparent;
  border-color: transparent;
  border-style: solid;
  border-width: 1px;
  border-radius: 3px;
}

.ezLightGrayBox {
  padding: 4px;
  background-color: var(--ezClockerOffWhite);
  color: var(--ezClockerBlack);
  border-color: var(----ezClockerGray);
  border-style: solid;
  border-width: 1px;
  border-radius: 3px;
}

.ezLightGrayBox8 {
  padding: 8px;
  background-color: var(--ezClockerOffWhite);
  color: var(--ezClockerBlack);
  border-color: var(----ezClockerGray);
  border-style: solid;
  border-width: 1px;
  border-radius: 3px;
}

.ezLightGrayMinBox {
  display: block;
  padding: 4px;
  background-color: var(--ezClockerOffWhite);
  color: var(--ezClockerBlack);
  border-color: var(----ezClockerGray);
  border-style: solid;
  border-width: 1px;
  border-radius: 3px;
}

.ezLightGrayMinBox8 {
  display: block;
  padding: 8px;
  background-color: var(--ezClockerOffWhite);
  color: var(--ezFontColor);
  border-color: var(--ezClockerGray);
  border-style: solid;
  border-width: 1px;
  border-radius: 3px;
}

.ezContainer-basic-silver {
  background-color: var(--ezClockerSilver);
}

.ezContainer-navy-8 {
  padding: 8px;
  background-color: var(--ezClockerNavy);
  color: var(--ezClockerWhite);
  font-weight: var(--ezTitleFontWeight);
  font-size: var(--ezTitleFontSize);
  border-radius: 3px;
}

.ezContainer-title-navy-8 {
  padding: 8px;
  background-color: var(--ezClockerNavy);
  color: var(--ezClockerWhite);
  font-weight: var(--ezTitleFontWeight);
  font-size: var(--ezTitleFontSize);
  border-color: var(--ezBorderNavy);
  border-style: solid;
  border-width: 1px;
  border-top-left-radius: 3px;
  border-top-right-radius: 3px;
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
}

.ezPageContent {
  margin-top: 4px;
  margin-left: 10px;
  margin-right: 10px;
  padding: 0;
  overflow: auto;
}

.ezPageContentBlock {
  display: grid;
  padding: 4px;
  grid-row-gap: 2px;
  row-gap: 2px;
  grid-column-gap: 2px;
  column-gap: 2px;
  background-color: var(--ezWhite);
  color: var(--ezFontColor);
  font-family: var(--ezFontFamily);
  font-size: var(--ezContentFontSize);
  font-weight: var(--ezContentFontWeight);
  font-style: var(--ezContentFontStyle);
}

.ezRightAlignedButtonContainer {
  margin-top: 10px;
  margin-bottom: 10px;
  padding: 8px;
  text-align: right;
  background-color: transparent;
}

.ezCenterAlignedContainer {
  padding: 4px;
  text-align: center;
  background-color: transparent;
}

.ez-error-details-container {
  margin-top: 10px;
  background-color: var(--ezClockerWhite);
  padding: 2px;
  color: var(--ezClockerGray);
  font-size: small;
  font-style: italic;
}

.ezContaner-image-box {
  padding: 0;
  margin: 0;
  background-color: transparent;
}

.ezContainer-dialog-buttons {
  display: grid;
  justify-content: end;
  align-content: center;
  grid-template-rows: 100%;
  grid-template-columns: auto;
}

.ezContainer-dialog-buttons-x2 {
  display: grid;
  margin-top: 20px;
  justify-content: end;
  align-content: center;
  grid-template-rows: 100%;
  grid-template-columns: auto auto;
  grid-column-gap: 8px;
  column-gap: 8px;
}

/* Legal Disclaimer Boxes */
.ezContainer_below-button-legal-disclaimer {
  display: grid;
  justify-content: end;
  align-content: left;
  grid-template-rows: auto;
  grid-template-columns: auto;
}

.ezContainer_legal-disclaimer-small-screens {
  display: none;
}

/* Footer Boxes */
.ezContainer-link-footer {
  display: grid;
  margin-top: 20px;
  justify-content: center;
  align-content: center;
  grid-template-rows: 100%;
  grid-template-columns: auto auto;
  grid-column-gap: 8px;
}

.ezContainer-legal-links {
  display: grid;
  grid-template-columns: auto auto auto;
  grid-column-gap: 4px;
  column-gap: 4px;
  grid-row-gap: 4px;
  row-gap: 4px;
  justify-content: stretch;
  align-content: center;
  padding: 4px;
  margin-top: 4px;
  background-color: var(--ezClockerWhite);
  color: var(--ezContentFontColor);
  font-family: var(--ezFontFamily);
  font-size: var(--ezContentFontSize);
  font-weight: var(--ezContentFontWeight);
  font-style: var(--ezContentFontStyle);
  border-color: var(--ezBorderColorStone);
  border-style: var(--ezBorderStyle);
  border-width: var(--ezBorderWidth);
}

.ezContainer-legal-link {
  display: grid;
  padding: 4px;
  align-content: stretch;
  text-align: center;
}

/* Margin Containers */
.ezContainer_TopMargin_8 {
  margin-top: 8px;
}

/* Border Containers */
.ezContainer-border-box {
  border-color: var(--ezClockerGray);
  border-style: solid;
  border-width: 1px;
}

.ezContainer-content-box {
  padding: 10px;
  background-color: var(--ezClockerWhite);
  color: var(--ezFontColor);
  border-color: var(--ezClockerSilver);
  border-style: solid;
  border-width: 1px;
  border-radius: 4px;
}

.ezContainer-scroll-box {
  padding: 8px;
  overflow: auto;
  border-style: solid;
  border-width: 1px;
  border-color: var(--ezClockerGray);
  box-shadow: inset 0 0 1px 1px rgb(109 110 112/50%);
}

.ezContainer-side-help-box {
  display: grid;
  grid-template-columns: auto;
  grid-template-rows: auto auto;
  justify-content: start;
  align-content: start;
  margin-top: 0;
  padding: 4px;
  color: var(--ezClockerBlack);
  font-size: 12pt;
  overflow: auto;
}

.ezContainer-side-help-box-img {
  height: 32px;
  vertical-align: middle;
}

.ezContainer-side-help-box-title {
  color: var(--ezClockerNavy);
  font-size: 14pt;
  font-weight: bold;
  border-bottom-color: var(--ezClockerGray);
  border-bottom-style: solid;
  border-bottom-width: 1px;
}

.ezContainer-side-help-box-content {
  padding: 4px;
  color: var(--ezClockerBlack);
  font-size: 12pt;
}

.ezContainer-full-screen-overlay {
  display: grid;
  padding: 8px;
  grid-template-columns: auto;
  grid-template-rows: min-content auto;
  align-content: start;
  justify-content: stretch;
  background-color: transparent;
  overflow: hidden;
}

.ezContainer-integration-setup-header {
  padding: 8px;
  color: var(--ezFontColor);
  background-color: var(--ezClockerWhite);
  border-color: var(--ezClockerGray);
  border-style: solid;
  border-width: 2px;
  margin-bottom: 20px;
}

.ezContainer-integration-logo {
  display: grid;
  grid-template-columns: auto;
  grid-template-rows: min-content min-content;
  justify-content: start;
  align-content: center;
  text-align: left;
  font-size: 14pt;
  font-weight: bold;
}

.ezContainer-integration-logo-img {
  vertical-align: middle;
  text-align: left;
  height: 28px;
}

.ezContainer-integration-logo-img-nosize {
  text-align: left;
  vertical-align: middle;
}

.ezContainer-integration-logo-text {
  text-align: left;
  font-size: 14pt;
  font-weight: bold;
}

.ezContainer-integration-input-container {
  display: grid;
  width: 100%;
  height: 100%;
  grid-template-columns: auto;
  grid-template-rows: auto;
  align-content: start;
  justify-content: stretch;
  /*    border-color: var(--ezClockerNavy);
  border-width: 2px;*/
  border-style: none;
  overflow: auto;
}

.ezContainer-mini-help-box-img {
  height: 22px;
  vertical-align: middle;
}

.ezContainer-mini-help-box {
  padding: 4px;
  color: var(--ezClockerGray);
  font-size: 10pt;
  text-align: left;
}

.ezContainer-editor-info-box {
  margin-top: 4px;
  color: var(--ezClockerNavy);
  font-size: 10pt;
  text-align: left;
}

.ezContainer-input-info-box-white-text {
  margin-top: 4px;
  color: var(--ezClockerWhite);
  font-size: 10pt;
  text-align: left;
}

.ezContainer-input-info-box-black-text {
  margin-top: 4px;
  color: var(--ezClockerBlack);
  font-size: 10pt;
  text-align: left;
}

.ezContiner-ezClockerNavy-pad8 {
  padding: 8px;
  background-color: var(--ezClockerNavy);
  color: var(--ezClockerWhite);
  border-style: solid;
  border-width: 1px;
  border-color: var(--ezBorderNavy);
  border-radius: 3px;
}

.ezContiner-ezClockerNavy-pad8-top-margin-10 {
  margin-top: 10px;
  padding: 8px;
  background-color: var(--ezClockerNavy);
  color: var(--ezClockerWhite);
  border-style: solid;
  border-width: 1px;
  border-color: var(--ezBorderNavy);
  border-radius: 3px;
}

.ezContainer-display-contents {
  display: contents;
}

.ezContainer-glass-bubble-pad-8 {
  padding: 8px;
  background-color: var(--ezGlass-background);
  box-shadow: var(--ezGlass-box-shadow);
  color: var(--ezClockerBlack);
  border-color: var(--ezGlass-border);
  border-style: solid;
  border-width: 1px;
  border-radius: 3px;
}

.ezContainer-glass-bubble-pad-10 {
  padding: 10px;
  background-color: var(--ezGlass-background);
  box-shadow: var(--ezGlass-box-shadow);
  color: var(--ezClockerBlack);
  border-color: var(--ezGlass-border);
  border-style: solid;
  border-width: 1px;
  border-radius: 3px;
}

.ezContainer-glass-bubble-pad-20 {
  padding: 20px;
  background-color: var(--ezGlass-background);
  box-shadow: var(--ezGlass-box-shadow);
  color: var(--ezClockerBlack);
  border-color: var(--ezGlass-border);
  border-style: solid;
  border-width: 1px;
  border-radius: 3px;
}

.ezContainer-glass-bubble-pad-40 {
  padding: 40px;
  background-color: var(--ezGlass-background);
  box-shadow: var(--ezGlass-box-shadow);
  color: var(--ezClockerBlack);
  border-color: var(--ezGlass-border);
  border-style: solid;
  border-width: 1px;
  border-radius: 3px;
}

/* Input Containers */
.ezContainer-radio-input-box {
  display: contents;
  padding: 0;
  margin: 0;
  background: transparent;
  border-width: 0;
  border-style: none;
}

.ezContainer-radio-check-input {
  display: grid;
  grid-template-columns: auto auto;
  grid-template-rows: auto;
  align-content: middle;
  justify-content: start;
  grid-row-gap: 0;
  grid-column-gap: 8px;
}

.ezContainer-info-box-yellow {
  padding: 4px;
  background-color: var(--ezClockerInfoYellow);
  color: var(--ezClockerBlack);
  border-color: var(--ezBorderYellow);
  border-radius: 3px;
  border-style: solid;
}

.ezContainer-ezClockerYellow-pad8 {
  padding: 8px;
  background-color: var(--ezClockerYellow);
  color: var(--ezClockerBlack);
  border-style: solid;
  border-width: 1px;
  border-color: var(--ezBorderYellow);
  border-radius: 3px;
}

.ezContainer-contentBox-transparent {
  display: inline;
  background-color: transparent;
}

span.ezContainer-text {
  display: contents;
}

span.ezContainer-showids {
  display: contents;
  margin-left: 2px;
  margin-right: 2px;
  padding: 2px;
  font-size: 8pt;
}

/* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
| Category Container Styles
| A transparent container with a 10px pad on the left
|-----------------------------------------------------------------
| Template
|   ezContainer_<name>-<backoungd-color>-<left-padding>
|
| Available Styles
|   ezContainer_tabbox-transparent-8px
|   ezContainer_tabbox-transparent-10px
|   ezContainer_tabbox-transparent-20px
~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */
.ezContainer_tabbox-transparent-8px {
  padding-left: 10px;
}

.ezContainer_tabbox-transparent-10px {
  padding-left: 10px;
}

.ezContainer_tabbox-transparent-20px {
  padding-left: 20px;
}

/* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
| Category Container Styles
| A container with only a bottom border as an underline
|-----------------------------------------------------------------
| Template
|   ezContainer_<name>-<bottom-border-color>
|
| Available Styles
|   ezContainer_categorybox-navy
~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */
.ezContainer_categorybox-navy {
  margin-top: 20px;
  margin-bottom: 10px;
  padding: 0;
  padding-bottom: 4px;
  background-color: transparent;
  color: var(--ezClockerBlack);
  font-size: var(--ezFontSize);
  font-weight: bold;
  border-color: var(--ezClockerNavy);
  border-style: none;
  border-width: 0;
  border-bottom-style: solid;
  border-bottom-width: 2px;
}

.ezContainer-borderlessCategoryContent {
  margin-left: 0;
  margin-top: 10px;
  margin-bottom: 10px;
  margin-right: 10px;
  padding: 8px;
  background-color: var(--ezClockerWhite);
  color: var(--ezClockerBlack);
  font-size: var(--ezContentFontSize);
  border-style: none;
}

.ezContainer_CategoryContent {
  margin-left: 0;
  margin-top: 10px;
  margin-bottom: 10px;
  margin-right: 10px;
  padding: 8px;
  background-color: var(--ezClockerWhite);
  color: var(--ezClockerBlack);
  font-size: var(--ezContentFontSize);
  border-color: var(--ezClockerGray);
  border-style: solid;
  border-width: 1px;
}

.ezContainer-category-content-silver-border {
  margin-left: 0;
  margin-top: 10px;
  margin-bottom: 10px;
  margin-right: 10px;
  padding: 8px;
  background-color: rgba(224, 224, 224, 0.3);
  color: var(--ezClockerBlack);
  font-size: var(--ezContentFontSize);
  border-color: var(--ezClockerSilver);
  border-style: solid;
  border-width: 1px;
}

.ezContainer_EmployeeCard {
  padding: 4px;
  margin: 4px;
  background-color: var(--ezClockerNavy);
  color: var(--ezClockerWhite);
  border-style: solid;
  border-width: 2px;
  border-color: #032746;
}

.ezContainer-toolbutton {
  display: contents;
  padding-left: 4px;
  padding-right: 4px;
  background-color: transparent;
}

.ezContainer-archive-status {
  display: grid;
  padding: 2px;
  grid-template-columns: auto auto;
  grid-template-rows: 100%;
  color: var(--ezClockerNavy);
  font-size: 10pt;
  align-content: center;
  justify-content: end;
  border-style: none;
}

.ezContainer-unarchive-status {
  display: grid;
  grid-template-columns: auto auto;
  grid-template-rows: 100%;
  padding: 2px;
  background-color: transparent;
  color: var(--ezClockerWhite);
  font-size: 10pt;
  align-content: center;
  justify-content: end;
  border-style: none;
}

.ezContainer-title-box-ezClockerYellow-pad4 {
  padding: 4px;
  background-color: var(--ezClockerYellow);
  color: var(--ezClockerBlack);
  border-color: var(--ezBorderYellow);
  border-style: solid;
  border-width: 1px;
  border-radius: 0;
  border-top-left-radius: 3px;
  border-top-right-radius: 3px;
}

.ezContainer-title-box-ezClockerNavy-pad-4 {
  padding: 4px;
  background-color: var(--ezClockerNavy);
  color: var(--ezClockerWhite);
  font-weight: bold;
  border-color: var(--ezBorderNavy);
  border-style: solid;
  border-width: 1px;
  border-top-left-radius: 3px;
  border-bottom-left-radius: 0;
  border-top-right-radius: 3px;
  border-bottom-right-radius: 0;
}

.ezContainer-title-box-ezClockerNavy-pad-8 {
  padding: 8px;
  background-color: var(--ezClockerNavy);
  color: var(--ezClockerWhite);
  font-weight: bold;
  border-color: var(--ezBorderNavy);
  border-style: solid;
  border-width: 1px;
  border-top-left-radius: 3px;
  border-bottom-left-radius: 0;
  border-top-right-radius: 3px;
  border-bottom-right-radius: 0;
}

/* -------------------------------------------------------------------
| Large Tablet Screen Styles (https://yesviz.com/laptops.php)       |
------------------------------------------------------------------- */
@media screen and (max-width: 1023px) {
  .ezContainer-dialog-buttons-x2 {
    display: grid;
    margin-top: 20px;
    justify-content: stretch;
    align-content: center;
    grid-template-rows: 100%;
    grid-template-columns: auto auto;
    grid-column-gap: 8px;
    column-gap: 8px;
  }
}
/* -------------------------------------------------------------------
| Small Tablet Screen Styles (https://yesviz.com/tablets.php)       |
------------------------------------------------------------------- */
@media screen and (max-width: 768px) {
  /*
  .ezContainers_InputBox {
      display: grid;
      padding: 0;
      grid-template-columns: 100%;
      grid-template-rows: 50% 50%;
      justify-content: start;
      align-content: center;
      background-color: transparent;
      color: var(--ezFontColor);
  }

  .ezContaner_CenterInputBox {
      display: grid;
      padding: 0;
      grid-template-columns: 100%;
      grid-template-rows: auto auto;
      justify-content: stretch;
      align-content: center;
      background-color: transparent;
      color: var(--ezFontColor);
  }

  .ezContainer-dialog-buttons-x2 {
      display: grid;
      margin-top: 20px;
      justify-content: stretch;
      align-content: center;
      grid-template-rows: 100%;
      grid-template-columns: auto auto;
      grid-column-gap: 8px;
      column-gap: 8px;
  }

  .ezContainer_below-button-legal-disclaimer {
      display: none;
  }

  .ezContainer_legal-disclaimer-small-screens {
      display: grid;
      justify-content: left;
      align-content: left;
      grid-template-rows: auto;
      grid-template-columns: auto;
  }

  .ezContainer-link-footer {
      display: grid;
      margin-top: 20px;
      justify-content: center;
      align-content: center;
      grid-template-columns: 50%;
      grid-column-gap: 4px;
  }
  */
}
/* -------------------------------------------------------------------
| Phone Screen Styles  (https://yesviz.com/mobiles.php)             |
------------------------------------------------------------------- */
@media screen and (max-width: 480px) {
  .ezContainers_InputBox {
    display: grid;
    padding: 0;
    grid-template-columns: 100%;
    grid-template-rows: 50% 50%;
    justify-content: start;
    align-content: center;
    background-color: transparent;
    color: var(--ezFontColor);
  }
  .ezContaner_CenterInputBox {
    display: grid;
    padding: 0;
    grid-template-columns: 100%;
    grid-template-rows: auto auto;
    justify-content: stretch;
    align-content: center;
    background-color: transparent;
    color: var(--ezFontColor);
  }
  .ezContainer-dialog-buttons-x2 {
    display: grid;
    margin-top: 20px;
    justify-content: stretch;
    align-content: center;
    grid-template-rows: 100%;
    grid-template-columns: auto auto;
    grid-column-gap: 8px;
    column-gap: 8px;
  }
  .ezContainer_below-button-legal-disclaimer {
    display: none;
  }
  .ezContainer_legal-disclaimer-small-screens {
    display: grid;
    justify-content: left;
    align-content: left;
    grid-template-rows: auto;
    grid-template-columns: auto;
  }
  .ezContainer-legal-links {
    display: grid;
    grid-template-columns: auto;
    grid-column-gap: 2px;
    column-gap: 2px;
    grid-row-gap: 0;
    row-gap: 0;
    justify-content: center;
    align-content: center;
    padding: 0;
    margin-top: 2px;
    background-color: var(--ezClockerWhite);
    color: var(--ezContentFontColor);
    font-family: var(--ezFontFamily);
    font-size: var(--ezContentFontSize);
    font-weight: var(--ezContentFontWeight);
    font-style: var(--ezContentFontStyle);
    border-style: none;
  }
  .ezContainer-link-footer {
    display: grid;
    margin-top: 20px;
    justify-content: center;
    align-content: center;
    grid-template-columns: 50%;
    grid-column-gap: 4px;
  }
}
/* -------------------------------------------------------------------
| Warable Screen Style  (https://yesviz.com/watches.php)            |
------------------------------------------------------------------- */
@media screen and (max-width: 319px) {
  .ezContainers_InputBox {
    display: grid;
    padding: 0;
    grid-template-columns: 100%;
    grid-template-rows: 50% 50%;
    justify-content: start;
    align-content: center;
    background-color: transparent;
    color: var(--ezFontColor);
  }
  .ezContaner_CenterInputBox {
    display: grid;
    padding: 0;
    grid-template-columns: 100%;
    grid-template-rows: auto auto;
    justify-content: stretch;
    align-content: center;
    background-color: transparent;
    color: var(--ezFontColor);
  }
  .ezContainer-dialog-buttons-x2 {
    display: grid;
    margin-top: 8px;
    justify-content: stretch;
    align-content: center;
    grid-template-rows: 100%;
    grid-template-columns: auto auto;
    grid-column-gap: 2px;
    column-gap: 2px;
  }
  .ezContainer_below-button-legal-disclaimer {
    display: none;
  }
  .ezContainer_legal-disclaimer-small-screens {
    display: grid;
    justify-content: left;
    align-content: left;
    grid-template-rows: auto;
    grid-template-columns: auto;
  }
  .ezContainer-link-footer {
    display: grid;
    margin-top: 20px;
    justify-content: center;
    align-content: center;
    grid-template-columns: 50%;
    grid-column-gap: 4px;
  }
}`, "",{"version":3,"sources":["webpack://./public/styles/common/ez-containers.css"],"names":[],"mappings":"AAAA;;;iEAAA;AAKA;EACI,UAAA;EACA,6BAAA;EACA,yBAAA;AAAJ;;AAGA;EACI,WAAA;AAAJ;;AAGA;EACI,kBAAA;EACA,YAAA;EACA,UAAA;EACA,MAAA;EACA,0CAAA;EACA,2BAAA;EACA,mBAAA;EACA,kBAAA;AAAJ;;AAGA;EACI,kBAAA;EACA,YAAA;EACA,uCAAA;EACA,4BAAA;AAAJ;;AAGA,2BAAA;AACA;EACI,aAAA;EACA,2BAAA;EACA,6BAAA;EACA,iBAAA;EACA,oBAAA;EACA,wBAAA;EACA,kBAAA;EACA,UAAA;EACA,SAAA;EACA,6BAAA;EACA,4BAAA;EACA,kBAAA;AAAJ;;AAGA;EACI,aAAA;EACA,2BAAA;EACA,6BAAA;EACA,iBAAA;EACA,kBAAA;EACA,wBAAA;EACA,qBAAA;EACA,eAAA;EACA,kBAAA;EACA,6BAAA;EACA,4BAAA;EACA,kBAAA;AAAJ;;AAGA;EACI,kBAAA;EACA,YAAA;EACA,wCAAA;EACA,4BAAA;AAAJ;;AAGA;EACI,YAAA;EACA,6BAAA;EACA,yBAAA;EACA,kBAAA;AAAJ;;AAGA,6CAAA;AACA;EACI,aAAA;EACA,2BAAA;EACA,6BAAA;EACA,sBAAA;EACA,qBAAA;EACA,YAAA;EACA,6BAAA;EACA,yBAAA;AAAJ;;AAGA;EACI,aAAA;EACA,YAAA;EACA,2BAAA;EACA,6BAAA;EACA,sBAAA;EACA,qBAAA;EACA,6BAAA;EACA,yBAAA;AAAJ;;AAGA;EACI,aAAA;EACA,2BAAA;EACA,6BAAA;EACA,wBAAA;EACA,qBAAA;EACA,YAAA;EACA,6BAAA;EACA,yBAAA;AAAJ;;AAIA;EACI,aAAA;EACA,2BAAA;EACA,6BAAA;EACA,uBAAA;EACA,qBAAA;EACA,YAAA;EACA,6BAAA;EACA,yBAAA;AADJ;;AAIA;;EAEI,aAAA;EACA,YAAA;EACA,2BAAA;EACA,6BAAA;AADJ;;AAIA;;EAEI,eAAA;EACA,kBAAA;AADJ;;AAIA;EACI,WAAA;EACA,YAAA;EACA,gBAAA;EACA,eAAA;EACA,wCAAA;EACA,0BAAA;EACA,4BAAA;EACA,4BAAA;EACA,4BAAA;EACA,eAAA;EACA,qCAAA;EACA,mBAAA;EACA,iBAAA;AADJ;;AAIA;EACI,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,0CAAA;EACA,2DAAA;EACA,0BAAA;EACA,4BAAA;EACA,0BAAA;EACA,6BAAA;EACA,4BAAA;EACA,eAAA;EACA,mBAAA;EACA,iBAAA;EACA,qCAAA;EACA,kBAAA;AADJ;;AAIA;EACI,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,0CAAA;EACA,2DAAA;EACA,0BAAA;EACA,4BAAA;EACA,0BAAA;EACA,6BAAA;EACA,4BAAA;EACA,eAAA;EACA,mBAAA;EACA,iBAAA;EACA,qCAAA;EACA,kBAAA;AADJ;;AAIA;EACI,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,6CAAA;EACA,sEAAA;EACA,0BAAA;EACA,4BAAA;EACA,yBAAA;EACA,4BAAA;EACA,eAAA;EACA,mBAAA;EACA,iBAAA;EACA,0CAAA;EACA,kBAAA;AADJ;;AAKA;EACI,eAAA;EACA,kBAAA;EACA,YAAA;EACA,gBAAA;EACA,6CAAA;EACA,4BAAA;EACA,eAAA;EACA,0CAAA;EACA,mBAAA;EACA,kBAAA;EACA,iBAAA;AAFJ;;AAKA;EACI,kBAAA;EACA,YAAA;EACA,gBAAA;EACA,6CAAA;EACA,4BAAA;EACA,eAAA;EACA,qCAAA;EACA,mBAAA;EACA,kBAAA;EACA,iBAAA;AAFJ;;AAKA;EACI,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;EACA,kBAAA;EACA,0CAAA;EAEA,2DAAA;EACA,0BAAA;EACA,4BAAA;EACA,yBAAA;EACA,4BAAA;EACA,eAAA;EACA,mBAAA;EACA,iBAAA;EACA,qCAAA;AAHJ;;AAMA;EACI,SAAA;EACA,YAAA;EACA,kBAAA;AAHJ;;AAMA,oBAAA;AACA;EACI,eAAA;EACA,aAAA;EACA,YAAA;EACA,sCAAA;EACA,cAAA;EACA,4BAAA;EACA,mBAAA;EACA,iBAAA;EACA,qCAAA;EACA,sCAAA;EACA,YAAA;EACA,WAAA;AAHJ;;AAMA;EACI,YAAA;EACA,0CAAA;EACA,4BAAA;EACA,gCAAA;EACA,4BAAA;EACA,gCAAA;EACA,mBAAA;EACA,qCAAA;EACA,iBAAA;EACA,kBAAA;AAHJ;;AAMA;EACI,qBAAA;AAHJ;;AAMA;EACI,YAAA;EACA,4BAAA;EACA,uCAAA;EACA,mCAAA;EACA,mBAAA;EACA,iBAAA;EACA,kBAAA;AAHJ;;AAMA;EACI,YAAA;EACA,4BAAA;EACA,uCAAA;EACA,mCAAA;EACA,mBAAA;EACA,iBAAA;EACA,kBAAA;AAHJ;;AAMA;EACI,YAAA;EACA,4BAAA;EACA,wCAAA;EACA,qBAAA;EACA,mBAAA;EACA,iBAAA;EACA,kBAAA;AAHJ;;AAMA;EACI,YAAA;EACA,4BAAA;EACA,wCAAA;EACA,qBAAA;EACA,mBAAA;EACA,iBAAA;EACA,kBAAA;AAHJ;;AAMA;EACI,YAAA;EACA,wCAAA;EACA,4BAAA;EACA,mCAAA;EACA,mBAAA;EACA,iBAAA;EACA,kBAAA;AAHJ;;AAMA;;;;;;;;;;;;;;;CAAA;AAiBA;;EAGI,YAAA;EACA,4BAAA;EACA,uCAAA;EACA,kCAAA;EACA,mBAAA;EACA,iBAAA;EACA,kBAAA;AALJ;;AAQA;EACI,YAAA;EACA,4BAAA;EACA,uCAAA;EACA,kBAAA;AALJ;;AASA;;EAGI,YAAA;EACA,4BAAA;EACA,uCAAA;EACA,kCAAA;EACA,mBAAA;EACA,iBAAA;EACA,kBAAA;AAPJ;;AAUA;EACI,aAAA;EACA,uCAAA;EACA,4BAAA;EACA,kCAAA;EACA,mBAAA;EACA,iBAAA;EACA,kBAAA;AAPJ;;AAUA;EACI,aAAA;EACA,4BAAA;EACA,uCAAA;EACA,kCAAA;EACA,mBAAA;EACA,iBAAA;EACA,0BAAA;AAPJ;;AAUA;EACI,uCAAA;EACA,kBAAA;AAPJ;;AAUA;EACI,uCAAA;EACA,kBAAA;EACA,iDAAA;AAPJ;;AAUA;EACI,YAAA;EACA,uCAAA;EACA,4BAAA;EACA,iCAAA;AAPJ;;AAUA;EACI,YAAA;EACA,4BAAA;EACA,4CAAA;EACA,kCAAA;EACA,mBAAA;EACA,iBAAA;AAPJ;;AAUA;;;;;;;;;;CAAA;AAWA;EACI,YAAA;EACA,wCAAA;EACA,4BAAA;EACA,kCAAA;EACA,mBAAA;EACA,iBAAA;EACA,kBAAA;AAPJ;;AAUA;EACI,YAAA;EACA,wCAAA;EACA,4BAAA;EACA,kCAAA;EACA,mBAAA;EACA,iBAAA;EACA,kBAAA;AAPJ;;AAUA;EACI,aAAA;EACA,wCAAA;EACA,4BAAA;EACA,kCAAA;EACA,mBAAA;EACA,iBAAA;EACA,kBAAA;AAPJ;;AAUA;EACI,aAAA;EACA,wCAAA;EACA,4BAAA;EACA,kCAAA;EACA,mBAAA;EACA,iBAAA;EACA,0BAAA;AAPJ;;AAUA;EACI,wCAAA;EACA,kBAAA;EACA,iDAAA;AAPJ;;AAUA;EACI,YAAA;EACA,uCAAA;EACA,4BAAA;EACA,kCAAA;EACA,mBAAA;EACA,iBAAA;EACA,kBAAA;AAPJ;;AAUA;;;;;;;;;;CAAA;AAWA;EACI,YAAA;EACA,4BAAA;EACA,sCAAA;EACA,iCAAA;EACA,mBAAA;EACA,iBAAA;EACA,kBAAA;AAPJ;;AAUA;EACI,YAAA;EACA,4BAAA;EACA,sCAAA;EACA,iCAAA;EACA,mBAAA;EACA,iBAAA;EACA,kBAAA;AAPJ;;AAUA;EACI,YAAA;EACA,4BAAA;EACA,sCAAA;EACA,iCAAA;EACA,mBAAA;EACA,iBAAA;EACA,2BAAA;EACA,4BAAA;EACA,4BAAA;EACA,6BAAA;AAPJ;;AAUA;EACI,YAAA;EACA,4BAAA;EACA,sCAAA;EACA,iCAAA;EACA,mBAAA;EACA,2BAAA;EACA,4BAAA;EACA,4BAAA;EACA,6BAAA;AAPJ;;AAUA;EACI,YAAA;EACA,4BAAA;EACA,sCAAA;EACA,iCAAA;EACA,mBAAA;EACA,iBAAA;EACA,2BAAA;EACA,4BAAA;EACA,4BAAA;EACA,6BAAA;AAPJ;;AAUA;EACI,YAAA;EACA,uCAAA;EACA,4BAAA;EACA,kBAAA;EACA,kBAAA;AAPJ;;AAUA;EACI,aAAA;EACA,cAAA;EACA,eAAA;EACA,mBAAA;EACA,YAAA;EACA,uCAAA;EACA,oCAAA;EACA,mBAAA;EACA,iBAAA;EACA,kBAAA;AAPJ;;AAUA;EACI,gBAAA;EACA,mBAAA;EACA,YAAA;EACA,sCAAA;EACA,oCAAA;EACA,mBAAA;EACA,iBAAA;EACA,kBAAA;AAPJ;;AAUA;EACI,gBAAA;EACA,mBAAA;EACA,YAAA;EACA,sCAAA;EACA,iBAAA;EACA,oCAAA;EACA,mBAAA;EACA,iBAAA;EACA,kBAAA;AAPJ;;AAUA;EACI,aAAA;EACA,2BAAA;EACA,gBAAA;EACA,mBAAA;EACA,YAAA;EACA,6BAAA;AAPJ;;AAWA;EACI,YAAA;EACA,4BAAA;EACA,6BAAA;EACA,yBAAA;AARJ;;AAWA;EACI,YAAA;EACA,4BAAA;EACA,6BAAA;EACA,yBAAA;EACA,mBAAA;EACA,iBAAA;EACA,kBAAA;AARJ;;AAWA;EACI,YAAA;EACA,0CAAA;EACA,4BAAA;EACA,oCAAA;EACA,mBAAA;EACA,iBAAA;EACA,kBAAA;AARJ;;AAWA;EACI,YAAA;EACA,0CAAA;EACA,4BAAA;EACA,oCAAA;EACA,mBAAA;EACA,iBAAA;EACA,kBAAA;AARJ;;AAWA;EACI,cAAA;EACA,YAAA;EACA,0CAAA;EACA,4BAAA;EACA,oCAAA;EACA,mBAAA;EACA,iBAAA;EACA,kBAAA;AARJ;;AAWA;EACI,cAAA;EACA,YAAA;EACA,0CAAA;EACA,yBAAA;EACA,kCAAA;EACA,mBAAA;EACA,iBAAA;EACA,kBAAA;AARJ;;AAWA;EACI,wCAAA;AARJ;;AAWA;EACI,YAAA;EACA,sCAAA;EACA,4BAAA;EACA,qCAAA;EACA,iCAAA;EACA,kBAAA;AARJ;;AAWA;EACI,YAAA;EACA,sCAAA;EACA,4BAAA;EACA,qCAAA;EACA,iCAAA;EACA,iCAAA;EACA,mBAAA;EACA,iBAAA;EACA,2BAAA;EACA,4BAAA;EACA,4BAAA;EACA,6BAAA;AARJ;;AAWA;EACI,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,UAAA;EACA,cAAA;AARJ;;AAWA;EACI,aAAA;EACA,YAAA;EACA,iBAAA;EACA,YAAA;EACA,oBAAA;EACA,eAAA;EACA,gCAAA;EACA,yBAAA;EACA,gCAAA;EACA,mCAAA;EACA,uCAAA;EACA,qCAAA;AARJ;;AAYA;EACI,gBAAA;EACA,mBAAA;EACA,YAAA;EACA,iBAAA;EACA,6BAAA;AATJ;;AAYA;EACI,YAAA;EACA,kBAAA;EACA,6BAAA;AATJ;;AAYA;EACI,gBAAA;EACA,uCAAA;EACA,YAAA;EACA,2BAAA;EACA,gBAAA;EACA,kBAAA;AATJ;;AAYA;EACI,UAAA;EACA,SAAA;EACA,6BAAA;AATJ;;AAYA;EACI,aAAA;EACA,oBAAA;EACA,qBAAA;EACA,wBAAA;EACA,2BAAA;AATJ;;AAYA;EACI,aAAA;EACA,gBAAA;EACA,oBAAA;EACA,qBAAA;EACA,wBAAA;EACA,gCAAA;EACA,oBAAA;EACA,eAAA;AATJ;;AAYA,2BAAA;AACA;EACI,aAAA;EACA,oBAAA;EACA,mBAAA;EACA,wBAAA;EACA,2BAAA;AATJ;;AAYA;EACI,aAAA;AATJ;;AAYA,iBAAA;AACA;EACI,aAAA;EACA,gBAAA;EACA,uBAAA;EACA,qBAAA;EACA,wBAAA;EACA,gCAAA;EACA,oBAAA;AATJ;;AAYA;EACI,aAAA;EACA,qCAAA;EACA,oBAAA;EACA,eAAA;EACA,iBAAA;EACA,YAAA;EACA,wBAAA;EACA,qBAAA;EACA,YAAA;EACA,eAAA;EACA,uCAAA;EACA,gCAAA;EACA,gCAAA;EACA,mCAAA;EACA,uCAAA;EACA,qCAAA;EACA,uCAAA;EACA,kCAAA;EACA,kCAAA;AATJ;;AAYA;EACI,aAAA;EACA,YAAA;EACA,sBAAA;EACA,kBAAA;AATJ;;AAYA,sBAAA;AACA;EACI,eAAA;AATJ;;AAYA,sBAAA;AACA;EACI,kCAAA;EACA,mBAAA;EACA,iBAAA;AATJ;;AAYA;EACI,aAAA;EACA,uCAAA;EACA,yBAAA;EACA,oCAAA;EACA,mBAAA;EACA,iBAAA;EACA,kBAAA;AATJ;;AAaA;EACI,YAAA;EACA,cAAA;EACA,mBAAA;EACA,iBAAA;EACA,kCAAA;EACA,kDAAA;AAVJ;;AAaA;EACI,aAAA;EACA,2BAAA;EACA,6BAAA;EACA,sBAAA;EACA,oBAAA;EACA,aAAA;EACA,YAAA;EACA,4BAAA;EACA,eAAA;EACA,cAAA;AAVJ;;AAaA;EACI,YAAA;EACA,sBAAA;AAVJ;;AAaA;EACI,2BAAA;EACA,eAAA;EACA,iBAAA;EACA,yCAAA;EACA,0BAAA;EACA,wBAAA;AAVJ;;AAaA;EACI,YAAA;EACA,4BAAA;EACA,eAAA;AAVJ;;AAaA;EACI,aAAA;EACA,YAAA;EACA,2BAAA;EACA,oCAAA;EACA,oBAAA;EACA,wBAAA;EACA,6BAAA;EACA,gBAAA;AAVJ;;AAaA;EACI,YAAA;EACA,yBAAA;EACA,uCAAA;EACA,kCAAA;EACA,mBAAA;EACA,iBAAA;EACA,mBAAA;AAVJ;;AAaA;EACI,aAAA;EACA,2BAAA;EACA,2CAAA;EACA,sBAAA;EACA,qBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;AAVJ;;AAaA;EACI,sBAAA;EACA,gBAAA;EACA,YAAA;AAVJ;;AAaA;EACI,gBAAA;EACA,sBAAA;AAVJ;;AAaA;EACI,gBAAA;EACA,eAAA;EACA,iBAAA;AAVJ;;AAaA;EACI,aAAA;EACA,WAAA;EACA,YAAA;EACA,2BAAA;EACA,wBAAA;EACA,oBAAA;EACA,wBAAA;EACA;qBAAA;EAEA,kBAAA;EACA,cAAA;AAVJ;;AAaA;EACI,YAAA;EACA,sBAAA;AAVJ;;AAaA;EACI,YAAA;EACA,2BAAA;EACA,eAAA;EACA,gBAAA;AAVJ;;AAaA;EACI,eAAA;EACA,2BAAA;EACA,eAAA;EACA,gBAAA;AAVJ;;AAaA;EACI,eAAA;EACA,4BAAA;EACA,eAAA;EACA,gBAAA;AAVJ;;AAaA;EACI,eAAA;EACA,4BAAA;EACA,eAAA;EACA,gBAAA;AAVJ;;AAcA;EACI,YAAA;EACA,sCAAA;EACA,4BAAA;EACA,mBAAA;EACA,iBAAA;EACA,iCAAA;EACA,kBAAA;AAXJ;;AAcA;EACI,gBAAA;EACA,YAAA;EACA,sCAAA;EACA,4BAAA;EACA,mBAAA;EACA,iBAAA;EACA,iCAAA;EACA,kBAAA;AAXJ;;AAcA;EACI,iBAAA;AAXJ;;AAcA;EACI,YAAA;EACA,2CAAA;EACA,qCAAA;EACA,4BAAA;EACA,mCAAA;EACA,mBAAA;EACA,iBAAA;EACA,kBAAA;AAXJ;;AAcA;EACI,aAAA;EACA,2CAAA;EACA,qCAAA;EACA,4BAAA;EACA,mCAAA;EACA,mBAAA;EACA,iBAAA;EACA,kBAAA;AAXJ;;AAcA;EACI,aAAA;EACA,2CAAA;EACA,qCAAA;EACA,4BAAA;EACA,mCAAA;EACA,mBAAA;EACA,iBAAA;EACA,kBAAA;AAXJ;;AAcA;EACI,aAAA;EACA,2CAAA;EACA,qCAAA;EACA,4BAAA;EACA,mCAAA;EACA,mBAAA;EACA,iBAAA;EACA,kBAAA;AAXJ;;AAeA,qBAAA;AACA;EACI,iBAAA;EACA,UAAA;EACA,SAAA;EACA,uBAAA;EACA,eAAA;EACA,kBAAA;AAZJ;;AAeA;EACI,aAAA;EACA,gCAAA;EACA,wBAAA;EACA,qBAAA;EACA,sBAAA;EACA,eAAA;EACA,oBAAA;AAZJ;;AAeA;EACI,YAAA;EACA,4CAAA;EACA,4BAAA;EACA,mCAAA;EACA,kBAAA;EACA,mBAAA;AAZJ;;AAeA;EACI,YAAA;EACA,wCAAA;EACA,4BAAA;EACA,mBAAA;EACA,iBAAA;EACA,mCAAA;EACA,kBAAA;AAZJ;;AAeA;EACI,eAAA;EACA,6BAAA;AAZJ;;AAeA;EACI,iBAAA;AAZJ;;AAeA;EACI,iBAAA;EACA,gBAAA;EACA,iBAAA;EACA,YAAA;EACA,cAAA;AAZJ;;AAgBA;;;;;;;;;;;mEAAA;AAYA;EACI,kBAAA;AAbJ;;AAgBA;EACI,kBAAA;AAbJ;;AAgBA;EACI,kBAAA;AAbJ;;AAiBA;;;;;;;;;mEAAA;AAUA;EACI,gBAAA;EACA,mBAAA;EACA,UAAA;EACA,mBAAA;EACA,6BAAA;EACA,4BAAA;EACA,4BAAA;EACA,iBAAA;EACA,kCAAA;EACA,kBAAA;EACA,eAAA;EACA,0BAAA;EACA,wBAAA;AAdJ;;AAiBA;EACI,cAAA;EACA,gBAAA;EACA,mBAAA;EACA,kBAAA;EACA,YAAA;EACA,uCAAA;EACA,4BAAA;EACA,mCAAA;EACA,kBAAA;AAdJ;;AAiBA;EACI,cAAA;EACA,gBAAA;EACA,mBAAA;EACA,kBAAA;EACA,YAAA;EACA,uCAAA;EACA,4BAAA;EACA,mCAAA;EACA,kCAAA;EACA,mBAAA;EACA,iBAAA;AAdJ;;AAiBA;EACI,cAAA;EACA,gBAAA;EACA,mBAAA;EACA,kBAAA;EACA,YAAA;EACA,0CAAA;EACA,4BAAA;EACA,mCAAA;EACA,oCAAA;EACA,mBAAA;EACA,iBAAA;AAdJ;;AAiBA;EACI,YAAA;EACA,WAAA;EACA,sCAAA;EACA,4BAAA;EACA,mBAAA;EACA,iBAAA;EACA,qBAAA;AAdJ;;AAiBA;EACI,iBAAA;EACA,iBAAA;EACA,kBAAA;EACA,6BAAA;AAdJ;;AAiBA;EACI,aAAA;EACA,YAAA;EACA,gCAAA;EACA,wBAAA;EACA,2BAAA;EACA,eAAA;EACA,qBAAA;EACA,oBAAA;EACA,kBAAA;AAdJ;;AAiBA;EACI,aAAA;EACA,gCAAA;EACA,wBAAA;EACA,YAAA;EACA,6BAAA;EACA,4BAAA;EACA,eAAA;EACA,qBAAA;EACA,oBAAA;EACA,kBAAA;AAdJ;;AAiBA;EACI,YAAA;EACA,wCAAA;EACA,4BAAA;EACA,mCAAA;EACA,mBAAA;EACA,iBAAA;EACA,gBAAA;EACA,2BAAA;EACA,4BAAA;AAdJ;;AAiBA;EACI,YAAA;EACA,sCAAA;EACA,4BAAA;EACA,iBAAA;EACA,iCAAA;EACA,mBAAA;EACA,iBAAA;EACA,2BAAA;EACA,4BAAA;EACA,4BAAA;EACA,6BAAA;AAdJ;;AAiBA;EACI,YAAA;EACA,sCAAA;EACA,4BAAA;EACA,iBAAA;EACA,iCAAA;EACA,mBAAA;EACA,iBAAA;EACA,2BAAA;EACA,4BAAA;EACA,4BAAA;EACA,6BAAA;AAdJ;;AAiBA;;qEAAA;AAGA;EACI;IACI,aAAA;IACA,gBAAA;IACA,wBAAA;IACA,qBAAA;IACA,wBAAA;IACA,gCAAA;IACA,oBAAA;IACA,eAAA;EAdN;AACF;AAkBA;;qEAAA;AAGA;EACI;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;GAAA;AAsCJ;AAoBA;;qEAAA;AAGA;EACI;IACI,aAAA;IACA,UAAA;IACA,2BAAA;IACA,2BAAA;IACA,sBAAA;IACA,qBAAA;IACA,6BAAA;IACA,yBAAA;EAlBN;EAqBE;IACI,aAAA;IACA,UAAA;IACA,2BAAA;IACA,6BAAA;IACA,wBAAA;IACA,qBAAA;IACA,6BAAA;IACA,yBAAA;EAnBN;EAsBE;IACI,aAAA;IACA,gBAAA;IACA,wBAAA;IACA,qBAAA;IACA,wBAAA;IACA,gCAAA;IACA,oBAAA;IACA,eAAA;EApBN;EAuBE;IACI,aAAA;EArBN;EAwBE;IACI,aAAA;IACA,qBAAA;IACA,mBAAA;IACA,wBAAA;IACA,2BAAA;EAtBN;EAyBE;IACI,aAAA;IACA,2BAAA;IACA,oBAAA;IACA,eAAA;IACA,eAAA;IACA,UAAA;IACA,uBAAA;IACA,qBAAA;IACA,UAAA;IACA,eAAA;IACA,uCAAA;IACA,gCAAA;IACA,gCAAA;IACA,mCAAA;IACA,uCAAA;IACA,qCAAA;IACA,kBAAA;EAvBN;EA0BE;IACI,aAAA;IACA,gBAAA;IACA,uBAAA;IACA,qBAAA;IACA,0BAAA;IACA,oBAAA;EAxBN;AACF;AA4BA;;qEAAA;AAGA;EACI;IACI,aAAA;IACA,UAAA;IACA,2BAAA;IACA,2BAAA;IACA,sBAAA;IACA,qBAAA;IACA,6BAAA;IACA,yBAAA;EA1BN;EA6BE;IACI,aAAA;IACA,UAAA;IACA,2BAAA;IACA,6BAAA;IACA,wBAAA;IACA,qBAAA;IACA,6BAAA;IACA,yBAAA;EA3BN;EA8BE;IACI,aAAA;IACA,eAAA;IACA,wBAAA;IACA,qBAAA;IACA,wBAAA;IACA,gCAAA;IACA,oBAAA;IACA,eAAA;EA5BN;EA+BE;IACI,aAAA;EA7BN;EAgCE;IACI,aAAA;IACA,qBAAA;IACA,mBAAA;IACA,wBAAA;IACA,2BAAA;EA9BN;EAiCE;IACI,aAAA;IACA,gBAAA;IACA,uBAAA;IACA,qBAAA;IACA,0BAAA;IACA,oBAAA;EA/BN;AACF","sourcesContent":["/* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n| EzClocker Containers/Boxes UX CSS Classes\n| CSS variables defined in: /src/main/webapp/public/styles/common/ez-body.css\n~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */\n\n.ezContainer {\n    padding: 0;\n    background-color: transparent;\n    border-color: transparent;\n}\n\n.ezContainer-width-100 {\n    width: 100%;\n}\n\n.ez-debug-timezone-container {\n    position: absolute;\n    padding: 2px;\n    left: 10px;\n    top: 0;\n    background-color: var(--ezClockerBabyBlue);\n    color: var(--ezClockerGray);\n    font-size: xx-small;\n    font-style: italic;\n}\n\n.ezInstructionContainer {\n    border-style: none;\n    padding: 8px;\n    background-color: var(--ezClockerWhite);\n    color: var(--ezClockerBlack);\n}\n\n/* Input Containers/Boxes */\n.ezContainer-date-picker {\n    display: grid;\n    grid-template-columns: auto;\n    grid-template-rows: auto auto;\n    grid-row-gap: 4px;\n    grid-column-gap: 4px;\n    justify-content: stretch;\n    align-content: top;\n    padding: 0;\n    margin: 0;\n    background-color: transparent;\n    color: var(--ezClockerBlack);\n    border-style: none;\n}\n\n.ezContainer-labeled-input-vertical {\n    display: grid;\n    grid-template-columns: 100%;\n    grid-template-rows: auto auto;\n    grid-row-gap: 4px;\n    grid-column-gap: 0;\n    justify-content: stretch;\n    align-content: center;\n    margin-top: 8px;\n    margin-bottom: 8px;\n    background-color: transparent;\n    color: var(--ezClockerBlack);\n    border-style: none;\n}\n\n.ezInputContainer {\n    border-style: none;\n    padding: 8px;\n    background-color: var(--ezClockerSilver);\n    color: var(--ezClockerBlack);\n}\n\n.ezTransparentInputContainer {\n    padding: 8px;\n    background-color: transparent;\n    color: var(--ezFontColor);\n    border-style: none;\n}\n\n/* DEPRECATED: Switch to ezInputs-input-box */\n.ezInputBox {\n    display: grid;\n    grid-template-columns: 100%;\n    grid-template-rows: auto auto;\n    justify-content: start;\n    align-content: center;\n    padding: 4px;\n    background-color: transparent;\n    color: var(--ezFontColor);\n}\n\n.ezContainers_InputBox {\n    display: grid;\n    padding: 4px;\n    grid-template-columns: 100%;\n    grid-template-rows: auto auto;\n    justify-content: start;\n    align-content: center;\n    background-color: transparent;\n    color: var(--ezFontColor);\n}\n\n.ezContaner_CenterInputBox {\n    display: grid;\n    grid-template-columns: 100%;\n    grid-template-rows: auto auto;\n    justify-content: stretch;\n    align-content: center;\n    padding: 4px;\n    background-color: transparent;\n    color: var(--ezFontColor);\n}\n\n\n.ezCenterInputBox {\n    display: grid;\n    grid-template-columns: auto;\n    grid-template-rows: auto auto;\n    justify-content: center;\n    align-content: center;\n    padding: 4px;\n    background-color: transparent;\n    color: var(--ezFontColor);\n}\n\n.ezLargeInputBox,\n.ezContainers-large-input-box {\n    display: grid;\n    padding: 8px;\n    grid-template-columns: auto;\n    grid-template-rows: auto auto;\n}\n\n.ezSmallInputBox,\n.ezContainers-small-input-box {\n    margin-top: 4px;\n    margin-bottom: 4px;\n}\n\n.ezErrorContainer {\n    margin: 4px;\n    padding: 4px;\n    min-height: 20px;\n    min-width: 20px;\n    background-color: var(--ezLightAlertRed);\n    background-size: 20px 20px;\n    background-repeat: no-repeat;\n    background-position: 4px 4px;\n    color: var(--ezClockerBlack);\n    font-size: 12pt;\n    border-color: var(--ezBorderAlertRed);\n    border-style: solid;\n    border-width: 1px;\n}\n\n.ezErrorBox {\n    margin-top: 4px;\n    margin-bottom: 4px;\n    padding-top: 4px;\n    padding-right: 4px;\n    padding-bottom: 4px;\n    padding-left: 28px;\n    min-height: 20px;\n    min-width: 20px;\n    background-color: var(--ezClockerErrorRed);\n    background-image: url(\"/public/images/icons/error-red.svg\");\n    background-size: 20px 20px;\n    background-repeat: no-repeat;\n    background-position-x: 4px;\n    background-position-y: center;\n    color: var(--ezClockerBlack);\n    font-size: 12pt;\n    border-style: solid;\n    border-width: 1px;\n    border-color: var(--ezBorderAlertRed);\n    border-radius: 3px;\n}\n\n.ezContainer-validation-error-box {\n    margin-top: 4px;\n    margin-bottom: 4px;\n    padding-top: 4px;\n    padding-right: 4px;\n    padding-bottom: 4px;\n    padding-left: 28px;\n    min-height: 17px;\n    min-width: 17px;\n    background-color: var(--ezClockerErrorRed);\n    background-image: url(\"/public/images/icons/error-red.svg\");\n    background-size: 17px 17px;\n    background-repeat: no-repeat;\n    background-position-x: 4px;\n    background-position-y: center;\n    color: var(--ezClockerBlack);\n    font-size: 12pt;\n    border-style: solid;\n    border-width: 1px;\n    border-color: var(--ezBorderAlertRed);\n    border-radius: 3px;\n}\n\n.ezWarningBox {\n    margin-top: 4px;\n    margin-bottom: 4px;\n    padding-top: 4px;\n    padding-right: 4px;\n    padding-bottom: 4px;\n    padding-left: 28px;\n    min-height: 20px;\n    min-width: 20px;\n    background-color: var(--ezLightWarningYellow);\n    background-image: url(\"/public/images/icons/warn-triangle-yellow.svg\");\n    background-size: 20px 20px;\n    background-repeat: no-repeat;\n    background-position: left;\n    color: var(--ezClockerBlack);\n    font-size: 12pt;\n    border-style: solid;\n    border-width: 1px;\n    border-color: var(--ezBorderWarningYellow);\n    border-radius: 3px;\n\n}\n\n.ezContainer-warning-no-image {\n    margin-top: 8px;\n    margin-bottom: 8px;\n    padding: 8px;\n    min-height: 24px;\n    background-color: var(--ezLightWarningYellow);\n    color: var(--ezClockerBlack);\n    font-size: 12pt;\n    border-color: var(--ezBorderWarningYellow);\n    border-style: solid;\n    border-radius: 3px;\n    border-width: 1px;\n}\n\n.ezContainer-warning-no-image-thick-dark-alert-red-border {\n    margin-bottom: 8px;\n    padding: 8px;\n    min-height: 24px;\n    background-color: var(--ezLightWarningYellow);\n    color: var(--ezClockerBlack);\n    font-size: 12pt;\n    border-color: var(--ezBorderAlertRed);\n    border-style: solid;\n    border-radius: 3px;\n    border-width: 3px;\n}\n\n.ez-floating-error-container {\n    position: absolute;\n    margin-top: 4px;\n    margin-bottom: 4px;\n    padding-top: 4px;\n    padding-right: 4px;\n    padding-bottom: 4px;\n    padding-left: 28px;\n    background-color: var(--ezClockerErrorRed);\n\n    background-image: url(\"/public/images/icons/error-red.svg\");\n    background-size: 20px 20px;\n    background-repeat: no-repeat;\n    background-position: left;\n    color: var(--ezClockerBlack);\n    font-size: 12pt;\n    border-style: solid;\n    border-width: 1px;\n    border-color: var(--ezBorderAlertRed);\n}\n\n.ezCenterContainer {\n    margin: 0;\n    padding: 4px;\n    text-align: center;\n}\n\n/* ezClocker Boxes */\ndiv.ezQuickStatusBox {\n    position: fixed;\n    display: none;\n    z-index: 999;\n    background-color: rgb(128 128 128 / 40%);\n    font-size: 8pt;\n    color: var(--ezClockerBlack);\n    border-style: solid;\n    border-width: 2px;\n    border-color: var(--ezBorderBabyBlue);\n    box-shadow: 0 0 2px 2px rgb(0 0 0 / 40%);\n    padding: 2px;\n    margin: 4px;\n}\n\n.ezBabyBlueBox {\n    padding: 4px;\n    background-color: var(--ezClockerBabyBlue);\n    color: var(--ezClockerBlack);\n    font-family: var(--ezFontFamily);\n    font-size: var(--ezFontSize);\n    font-weight: var(--ezFontWeight);\n    border-style: solid;\n    border-color: var(--ezBorderBabyBlue);\n    border-width: 1px;\n    border-radius: 3px;\n}\n\n.ezContentsBox {\n    display: inline-block;\n}\n\n.ezBlackBox {\n    padding: 4px;\n    color: var(--ezClockerWhite);\n    background-color: var(--ezClockerBlack);\n    border-color: var(--ezClockerBlack);\n    border-style: solid;\n    border-width: 1px;\n    border-radius: 3px;\n}\n\n.ezBlackBox8 {\n    padding: 8px;\n    color: var(--ezClockerWhite);\n    background-color: var(--ezClockerBlack);\n    border-color: var(--ezClockerBlack);\n    border-style: solid;\n    border-width: 1px;\n    border-radius: 3px;\n}\n\n.ezSilverBox {\n    padding: 4px;\n    color: var(--ezClockerBlack);\n    background-color: var(--ezClockerSilver);\n    border-color: #a7a9ab;\n    border-style: solid;\n    border-width: 1px;\n    border-radius: 3px;\n}\n\n.ezSilverBox8 {\n    padding: 8px;\n    color: var(--ezClockerBlack);\n    background-color: var(--ezClockerSilver);\n    border-color: #a7a9ab;\n    border-style: solid;\n    border-width: 1px;\n    border-radius: 3px;\n}\n\n.ezContainer-ezClockerYellow-pad-4 {\n    padding: 8px;\n    background-color: var(--ezClockerYellow);\n    color: var(--ezClockerBlack);\n    border-color: var(--ezBorderYellow);\n    border-style: solid;\n    border-width: 1px;\n    border-radius: 3px;\n}\n\n/*\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n    ezClockerWhite containers\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n    Active\n        ezContainer-ezClockerWhite-pad-4\n        ezContainer-ezClockerWhite-pad-8\n        ezContainer-ezClockerWhite-pad-10\n        ezContainer-bottom-ezClockerWhite-pad-10\n        ezContainer-ezClockerWhite-shadow\n        ezContainer-default-ezClockerWhite\n        ezContainers-ezClockerWhite-small-help\n        (DEPRECATED) ezWhiteBox\n        (DEPRECATED) ezWhiteBox8\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n*/\n\n.ezContainer-ezClockerWhite-pad-4,\n/* DEPRECATED: .ezWhiteBox */\n.ezWhiteBox {\n    padding: 4px;\n    color: var(--ezClockerBlack);\n    background-color: var(--ezClockerWhite);\n    border-color: var(--ezClockerGray);\n    border-style: solid;\n    border-width: 1px;\n    border-radius: 3px;\n}\n\n.ezContainer-ezClockerWhite-pad-4-no-border {\n    padding: 4px;\n    color: var(--ezClockerBlack);\n    background-color: var(--ezClockerWhite);\n    border-style: none;\n}\n\n\n.ezContainer-ezClockerWhite-pad-8,\n/* DEPRECATED: .ezWhiteBox8 */\n.ezWhiteBox8 {\n    padding: 8px;\n    color: var(--ezClockerBlack);\n    background-color: var(--ezClockerWhite);\n    border-color: var(--ezClockerGray);\n    border-style: solid;\n    border-width: 1px;\n    border-radius: 3px;\n}\n\n.ezContainer-ezClockerWhite-pad-10 {\n    padding: 10px;\n    background-color: var(--ezClockerWhite);\n    color: var(--ezClockerBlack);\n    border-color: var(--ezClockerGray);\n    border-style: solid;\n    border-width: 1px;\n    border-radius: 3px;\n}\n\n.ezContainer-bottom-ezClockerWhite-pad-10 {\n    padding: 10px;\n    color: var(--ezClockerBlack);\n    background-color: var(--ezClockerWhite);\n    border-color: var(--ezClockerGray);\n    border-style: solid;\n    border-width: 1px;\n    border-radius: 0 0 3px 3px;\n}\n\n.ezContainer-default-ezClockerWhite {\n    background-color: var(--ezClockerWhite);\n    border-style: none;\n}\n\n.ezContainer-ezClockerWhite-shadow {\n    background-color: var(--ezClockerWhite);\n    border-style: none;\n    box-shadow: 4px 4px 8px -2px var(--ezClockerGray);\n}\n\n.ezContainers-ezClockerWhite-small-content {\n    padding: 4px;\n    background-color: var(--ezClockerWhite);\n    color: var(--ezClockerBlack);\n    font-size: var(--ezSmallFontSize);\n}\n\n.ezContainers-ezMobileBlue-pad2 {\n    padding: 2px;\n    color: var(--ezClockerWhite);\n    background-color: var(--ezClockerMobileBlue);\n    border-color: var(--ezClockerGray);\n    border-style: solid;\n    border-width: 2px;\n}\n\n/*\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n    ezClockerSilver containers\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n    Active\n        ezContainer-ezClockerSilver-pad-8\n        ezContainer-ezClockerSilver-pad-10\n        ezContainer-bottom-ezClockerSilver-pad-10\n        ezContainer-ezClockerSilver-shadow\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n*/\n.ezContainer-ezClockerSilver-pad-4 {\n    padding: 4px;\n    background-color: var(--ezClockerSilver);\n    color: var(--ezClockerBlack);\n    border-color: var(--ezClockerGray);\n    border-style: solid;\n    border-width: 1px;\n    border-radius: 3px;\n}\n\n.ezContainer-ezClockerSilver-pad-8 {\n    padding: 8px;\n    background-color: var(--ezClockerSilver);\n    color: var(--ezClockerBlack);\n    border-color: var(--ezClockerGray);\n    border-style: solid;\n    border-width: 1px;\n    border-radius: 3px;\n}\n\n.ezContainer-ezClockerSilver-pad-10 {\n    padding: 10px;\n    background-color: var(--ezClockerSilver);\n    color: var(--ezClockerBlack);\n    border-color: var(--ezClockerGray);\n    border-style: solid;\n    border-width: 1px;\n    border-radius: 3px;\n}\n\n.ezContainer-bottom-ezClockerSilver-pad-10 {\n    padding: 10px;\n    background-color: var(--ezClockerSilver);\n    color: var(--ezClockerBlack);\n    border-color: var(--ezClockerGray);\n    border-style: solid;\n    border-width: 1px;\n    border-radius: 0 0 3px 3px;\n}\n\n.ezContainer-ezClockerSilver-shadow {\n    background-color: var(--ezClockerSilver);\n    border-style: none;\n    box-shadow: 4px 4px 8px -2px var(--ezClockerGray);\n}\n\n.ezContainer-ezClockerStone-pad-8 {\n    padding: 8px;\n    background-color: var(--ezClockerStone);\n    color: var(--ezClockerBlack);\n    border-color: var(--ezClockerGray);\n    border-style: solid;\n    border-width: 1px;\n    border-radius: 3px;\n}\n\n/*\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n    ezClockerNavy containers\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n    Active\n        ezContainer-navy4\n        ezContainer-navy8\n        ezContainer-top-navy4\n        ezContainer-top-navy8\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n*/\n.ezContainer-navy4 {\n    padding: 4px;\n    color: var(--ezClockerWhite);\n    background-color: var(--ezClockerNavy);\n    border-color: var(--ezBorderNavy);\n    border-style: solid;\n    border-width: 1px;\n    border-radius: 3px;\n}\n\n.ezContainer-navy8 {\n    padding: 8px;\n    color: var(--ezClockerWhite);\n    background-color: var(--ezClockerNavy);\n    border-color: var(--ezBorderNavy);\n    border-style: solid;\n    border-width: 1px;\n    border-radius: 3px;\n}\n\n.ezContainer-top-navy4 {\n    padding: 4px;\n    color: var(--ezClockerWhite);\n    background-color: var(--ezClockerNavy);\n    border-color: var(--ezBorderNavy);\n    border-style: solid;\n    border-width: 1px;\n    border-top-left-radius: 3px;\n    border-top-right-radius: 3px;\n    border-bottom-left-radius: 0;\n    border-bottom-right-radius: 0;\n}\n\n.ezContainer-top-navy8 {\n    padding: 8px;\n    color: var(--ezClockerWhite);\n    background-color: var(--ezClockerNavy);\n    border-color: var(--ezBorderNavy);\n    border-style: solid;\n    border-top-left-radius: 3px;\n    border-top-right-radius: 3px;\n    border-bottom-left-radius: 0;\n    border-bottom-right-radius: 0;\n}\n\n.ezContainer-top-gray4 {\n    padding: 4px;\n    color: var(--ezClockerWhite);\n    background-color: var(--ezClockerGray);\n    border-color: var(--ezBorderGray);\n    border-style: solid;\n    border-width: 1px;\n    border-top-left-radius: 3px;\n    border-top-right-radius: 3px;\n    border-bottom-left-radius: 0;\n    border-bottom-right-radius: 0;\n}\n\n.ez-white-borderless-box8 {\n    padding: 8px;\n    background-color: var(--ezClockerWhite);\n    color: var(--ezClockerBlack);\n    border-style: none;\n    border-radius: 3px;\n}\n\n.ezContainer-white-border-pad8-bottom-margin10 {\n    margin-top: 0;\n    margin-left: 0;\n    margin-right: 0;\n    margin-bottom: 10px;\n    padding: 8px;\n    background-color: var(--ezClockerWhite);\n    border-color: var(--ezClockerSilver);\n    border-style: solid;\n    border-width: 1px;\n    border-radius: 3px;\n}\n\n.ezContainer-alpha-white-silver-border-8 {\n    margin-top: 10px;\n    margin-bottom: 10px;\n    padding: 8px;\n    background-color: rgb(255 255 255 / 50%);\n    border-color: var(--ezClockerSilver);\n    border-style: solid;\n    border-width: 1px;\n    border-radius: 3px;\n}\n\n.ezContainer-white-right-aligned-button-container {\n    margin-top: 10px;\n    margin-bottom: 10px;\n    padding: 8px;\n    background-color: rgb(255 255 255 / 50%);\n    text-align: right;\n    border-color: var(--ezClockerSilver);\n    border-style: solid;\n    border-width: 1px;\n    border-radius: 3px;\n}\n\n.ezContainer-transparent-button-bar-no-border {\n    display: flex;\n    flex-direction: row-reverse;\n    margin-top: 10px;\n    margin-bottom: 10px;\n    padding: 8px;\n    background-color: transparent;\n}\n\n\n.ezTransparentBox {\n    padding: 4px;\n    color: var(--ezClockerBlack);\n    background-color: transparent;\n    border-color: transparent;\n}\n\n.ezTransparentBox8 {\n    padding: 8px;\n    color: var(--ezClockerBlack);\n    background-color: transparent;\n    border-color: transparent;\n    border-style: solid;\n    border-width: 1px;\n    border-radius: 3px;\n}\n\n.ezLightGrayBox {\n    padding: 4px;\n    background-color: var(--ezClockerOffWhite);\n    color: var(--ezClockerBlack);\n    border-color: var(----ezClockerGray);\n    border-style: solid;\n    border-width: 1px;\n    border-radius: 3px;\n}\n\n.ezLightGrayBox8 {\n    padding: 8px;\n    background-color: var(--ezClockerOffWhite);\n    color: var(--ezClockerBlack);\n    border-color: var(----ezClockerGray);\n    border-style: solid;\n    border-width: 1px;\n    border-radius: 3px;\n}\n\n.ezLightGrayMinBox {\n    display: block;\n    padding: 4px;\n    background-color: var(--ezClockerOffWhite);\n    color: var(--ezClockerBlack);\n    border-color: var(----ezClockerGray);\n    border-style: solid;\n    border-width: 1px;\n    border-radius: 3px;\n}\n\n.ezLightGrayMinBox8 {\n    display: block;\n    padding: 8px;\n    background-color: var(--ezClockerOffWhite);\n    color: var(--ezFontColor);\n    border-color: var(--ezClockerGray);\n    border-style: solid;\n    border-width: 1px;\n    border-radius: 3px;\n}\n\n.ezContainer-basic-silver {\n    background-color: var(--ezClockerSilver);\n}\n\n.ezContainer-navy-8 {\n    padding: 8px;\n    background-color: var(--ezClockerNavy);\n    color: var(--ezClockerWhite);\n    font-weight: var(--ezTitleFontWeight);\n    font-size: var(--ezTitleFontSize);\n    border-radius: 3px;\n}\n\n.ezContainer-title-navy-8 {\n    padding: 8px;\n    background-color: var(--ezClockerNavy);\n    color: var(--ezClockerWhite);\n    font-weight: var(--ezTitleFontWeight);\n    font-size: var(--ezTitleFontSize);\n    border-color: var(--ezBorderNavy);\n    border-style: solid;\n    border-width: 1px;\n    border-top-left-radius: 3px;\n    border-top-right-radius: 3px;\n    border-bottom-left-radius: 0;\n    border-bottom-right-radius: 0;\n}\n\n.ezPageContent {\n    margin-top: 4px;\n    margin-left: 10px;\n    margin-right: 10px;\n    padding: 0;\n    overflow: auto;\n}\n\n.ezPageContentBlock {\n    display: grid;\n    padding: 4px;\n    grid-row-gap: 2px;\n    row-gap: 2px;\n    grid-column-gap: 2px;\n    column-gap: 2px;\n    background-color: var(--ezWhite);\n    color: var(--ezFontColor);\n    font-family: var(--ezFontFamily);\n    font-size: var(--ezContentFontSize);\n    font-weight: var(--ezContentFontWeight);\n    font-style: var(--ezContentFontStyle);\n\n}\n\n.ezRightAlignedButtonContainer {\n    margin-top: 10px;\n    margin-bottom: 10px;\n    padding: 8px;\n    text-align: right;\n    background-color: transparent;\n}\n\n.ezCenterAlignedContainer {\n    padding: 4px;\n    text-align: center;\n    background-color: transparent;\n}\n\n.ez-error-details-container {\n    margin-top: 10px;\n    background-color: var(--ezClockerWhite);\n    padding: 2px;\n    color: var(--ezClockerGray);\n    font-size: small;\n    font-style: italic;\n}\n\n.ezContaner-image-box {\n    padding: 0;\n    margin: 0;\n    background-color: transparent;\n}\n\n.ezContainer-dialog-buttons {\n    display: grid;\n    justify-content: end;\n    align-content: center;\n    grid-template-rows: 100%;\n    grid-template-columns: auto;\n}\n\n.ezContainer-dialog-buttons-x2 {\n    display: grid;\n    margin-top: 20px;\n    justify-content: end;\n    align-content: center;\n    grid-template-rows: 100%;\n    grid-template-columns: auto auto;\n    grid-column-gap: 8px;\n    column-gap: 8px;\n}\n\n/* Legal Disclaimer Boxes */\n.ezContainer_below-button-legal-disclaimer {\n    display: grid;\n    justify-content: end;\n    align-content: left;\n    grid-template-rows: auto;\n    grid-template-columns: auto;\n}\n\n.ezContainer_legal-disclaimer-small-screens {\n    display: none;\n}\n\n/* Footer Boxes */\n.ezContainer-link-footer {\n    display: grid;\n    margin-top: 20px;\n    justify-content: center;\n    align-content: center;\n    grid-template-rows: 100%;\n    grid-template-columns: auto auto;\n    grid-column-gap: 8px;\n}\n\n.ezContainer-legal-links {\n    display: grid;\n    grid-template-columns: auto auto auto;\n    grid-column-gap: 4px;\n    column-gap: 4px;\n    grid-row-gap: 4px;\n    row-gap: 4px;\n    justify-content: stretch;\n    align-content: center;\n    padding: 4px;\n    margin-top: 4px;\n    background-color: var(--ezClockerWhite);\n    color: var(--ezContentFontColor);\n    font-family: var(--ezFontFamily);\n    font-size: var(--ezContentFontSize);\n    font-weight: var(--ezContentFontWeight);\n    font-style: var(--ezContentFontStyle);\n    border-color: var(--ezBorderColorStone);\n    border-style: var(--ezBorderStyle);\n    border-width: var(--ezBorderWidth);\n}\n\n.ezContainer-legal-link {\n    display: grid;\n    padding: 4px;\n    align-content: stretch;\n    text-align: center;\n}\n\n/* Margin Containers */\n.ezContainer_TopMargin_8 {\n    margin-top: 8px;\n}\n\n/* Border Containers */\n.ezContainer-border-box {\n    border-color: var(--ezClockerGray);\n    border-style: solid;\n    border-width: 1px;\n}\n\n.ezContainer-content-box {\n    padding: 10px;\n    background-color: var(--ezClockerWhite);\n    color: var(--ezFontColor);\n    border-color: var(--ezClockerSilver);\n    border-style: solid;\n    border-width: 1px;\n    border-radius: 4px;\n\n}\n\n.ezContainer-scroll-box {\n    padding: 8px;\n    overflow: auto;\n    border-style: solid;\n    border-width: 1px;\n    border-color: var(--ezClockerGray);\n    box-shadow: inset 0 0 1px 1px rgb(109 110 112 / 50%);\n}\n\n.ezContainer-side-help-box {\n    display: grid;\n    grid-template-columns: auto;\n    grid-template-rows: auto auto;\n    justify-content: start;\n    align-content: start;\n    margin-top: 0;\n    padding: 4px;\n    color: var(--ezClockerBlack);\n    font-size: 12pt;\n    overflow: auto;\n}\n\n.ezContainer-side-help-box-img {\n    height: 32px;\n    vertical-align: middle;\n}\n\n.ezContainer-side-help-box-title {\n    color: var(--ezClockerNavy);\n    font-size: 14pt;\n    font-weight: bold;\n    border-bottom-color: var(--ezClockerGray);\n    border-bottom-style: solid;\n    border-bottom-width: 1px;\n}\n\n.ezContainer-side-help-box-content {\n    padding: 4px;\n    color: var(--ezClockerBlack);\n    font-size: 12pt;\n}\n\n.ezContainer-full-screen-overlay {\n    display: grid;\n    padding: 8px;\n    grid-template-columns: auto;\n    grid-template-rows: min-content auto;\n    align-content: start;\n    justify-content: stretch;\n    background-color: transparent;\n    overflow: hidden;\n}\n\n.ezContainer-integration-setup-header {\n    padding: 8px;\n    color: var(--ezFontColor);\n    background-color: var(--ezClockerWhite);\n    border-color: var(--ezClockerGray);\n    border-style: solid;\n    border-width: 2px;\n    margin-bottom: 20px;\n}\n\n.ezContainer-integration-logo {\n    display: grid;\n    grid-template-columns: auto;\n    grid-template-rows: min-content min-content;\n    justify-content: start;\n    align-content: center;\n    text-align: left;\n    font-size: 14pt;\n    font-weight: bold;\n}\n\n.ezContainer-integration-logo-img {\n    vertical-align: middle;\n    text-align: left;\n    height: 28px;\n}\n\n.ezContainer-integration-logo-img-nosize {\n    text-align: left;\n    vertical-align: middle;\n}\n\n.ezContainer-integration-logo-text {\n    text-align: left;\n    font-size: 14pt;\n    font-weight: bold;\n}\n\n.ezContainer-integration-input-container {\n    display: grid;\n    width: 100%;\n    height: 100%;\n    grid-template-columns: auto;\n    grid-template-rows: auto;\n    align-content: start;\n    justify-content: stretch;\n    /*    border-color: var(--ezClockerNavy);\n    border-width: 2px;*/\n    border-style: none;\n    overflow: auto;\n}\n\n.ezContainer-mini-help-box-img {\n    height: 22px;\n    vertical-align: middle;\n}\n\n.ezContainer-mini-help-box {\n    padding: 4px;\n    color: var(--ezClockerGray);\n    font-size: 10pt;\n    text-align: left;\n}\n\n.ezContainer-editor-info-box {\n    margin-top: 4px;\n    color: var(--ezClockerNavy);\n    font-size: 10pt;\n    text-align: left;\n}\n\n.ezContainer-input-info-box-white-text {\n    margin-top: 4px;\n    color: var(--ezClockerWhite);\n    font-size: 10pt;\n    text-align: left;\n}\n\n.ezContainer-input-info-box-black-text {\n    margin-top: 4px;\n    color: var(--ezClockerBlack);\n    font-size: 10pt;\n    text-align: left;\n}\n\n\n.ezContiner-ezClockerNavy-pad8 {\n    padding: 8px;\n    background-color: var(--ezClockerNavy);\n    color: var(--ezClockerWhite);\n    border-style: solid;\n    border-width: 1px;\n    border-color: var(--ezBorderNavy);\n    border-radius: 3px;\n}\n\n.ezContiner-ezClockerNavy-pad8-top-margin-10 {\n    margin-top: 10px;\n    padding: 8px;\n    background-color: var(--ezClockerNavy);\n    color: var(--ezClockerWhite);\n    border-style: solid;\n    border-width: 1px;\n    border-color: var(--ezBorderNavy);\n    border-radius: 3px;\n}\n\n.ezContainer-display-contents {\n    display: contents;\n}\n\n.ezContainer-glass-bubble-pad-8 {\n    padding: 8px;\n    background-color: var(--ezGlass-background);\n    box-shadow: var(--ezGlass-box-shadow);\n    color: var(--ezClockerBlack);\n    border-color: var(--ezGlass-border);\n    border-style: solid;\n    border-width: 1px;\n    border-radius: 3px;\n}\n\n.ezContainer-glass-bubble-pad-10 {\n    padding: 10px;\n    background-color: var(--ezGlass-background);\n    box-shadow: var(--ezGlass-box-shadow);\n    color: var(--ezClockerBlack);\n    border-color: var(--ezGlass-border);\n    border-style: solid;\n    border-width: 1px;\n    border-radius: 3px;\n}\n\n.ezContainer-glass-bubble-pad-20 {\n    padding: 20px;\n    background-color: var(--ezGlass-background);\n    box-shadow: var(--ezGlass-box-shadow);\n    color: var(--ezClockerBlack);\n    border-color: var(--ezGlass-border);\n    border-style: solid;\n    border-width: 1px;\n    border-radius: 3px;\n}\n\n.ezContainer-glass-bubble-pad-40 {\n    padding: 40px;\n    background-color: var(--ezGlass-background);\n    box-shadow: var(--ezGlass-box-shadow);\n    color: var(--ezClockerBlack);\n    border-color: var(--ezGlass-border);\n    border-style: solid;\n    border-width: 1px;\n    border-radius: 3px;\n}\n\n\n/* Input Containers */\n.ezContainer-radio-input-box {\n    display: contents;\n    padding: 0;\n    margin: 0;\n    background: transparent;\n    border-width: 0;\n    border-style: none;\n}\n\n.ezContainer-radio-check-input {\n    display: grid;\n    grid-template-columns: auto auto;\n    grid-template-rows: auto;\n    align-content: middle;\n    justify-content: start;\n    grid-row-gap: 0;\n    grid-column-gap: 8px;\n}\n\n.ezContainer-info-box-yellow {\n    padding: 4px;\n    background-color: var(--ezClockerInfoYellow);\n    color: var(--ezClockerBlack);\n    border-color: var(--ezBorderYellow);\n    border-radius: 3px;\n    border-style: solid;\n}\n\n.ezContainer-ezClockerYellow-pad8 {\n    padding: 8px;\n    background-color: var(--ezClockerYellow);\n    color: var(--ezClockerBlack);\n    border-style: solid;\n    border-width: 1px;\n    border-color: var(--ezBorderYellow);\n    border-radius: 3px;\n}\n\n.ezContainer-contentBox-transparent {\n    display: inline;\n    background-color: transparent;\n}\n\nspan.ezContainer-text {\n    display: contents;\n}\n\nspan.ezContainer-showids {\n    display: contents;\n    margin-left: 2px;\n    margin-right: 2px;\n    padding: 2px;\n    font-size: 8pt;\n}\n\n\n/* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n| Category Container Styles\n| A transparent container with a 10px pad on the left\n|-----------------------------------------------------------------\n| Template\n|   ezContainer_<name>-<backoungd-color>-<left-padding>\n|\n| Available Styles\n|   ezContainer_tabbox-transparent-8px\n|   ezContainer_tabbox-transparent-10px\n|   ezContainer_tabbox-transparent-20px\n~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */\n.ezContainer_tabbox-transparent-8px {\n    padding-left: 10px;\n}\n\n.ezContainer_tabbox-transparent-10px {\n    padding-left: 10px;\n}\n\n.ezContainer_tabbox-transparent-20px {\n    padding-left: 20px;\n}\n\n\n/* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n| Category Container Styles\n| A container with only a bottom border as an underline\n|-----------------------------------------------------------------\n| Template\n|   ezContainer_<name>-<bottom-border-color>\n|\n| Available Styles\n|   ezContainer_categorybox-navy\n~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */\n.ezContainer_categorybox-navy {\n    margin-top: 20px;\n    margin-bottom: 10px;\n    padding: 0;\n    padding-bottom: 4px;\n    background-color: transparent;\n    color: var(--ezClockerBlack);\n    font-size: var(--ezFontSize);\n    font-weight: bold;\n    border-color: var(--ezClockerNavy);\n    border-style: none;\n    border-width: 0;\n    border-bottom-style: solid;\n    border-bottom-width: 2px;\n}\n\n.ezContainer-borderlessCategoryContent {\n    margin-left: 0;\n    margin-top: 10px;\n    margin-bottom: 10px;\n    margin-right: 10px;\n    padding: 8px;\n    background-color: var(--ezClockerWhite);\n    color: var(--ezClockerBlack);\n    font-size: var(--ezContentFontSize);\n    border-style: none;\n}\n\n.ezContainer_CategoryContent {\n    margin-left: 0;\n    margin-top: 10px;\n    margin-bottom: 10px;\n    margin-right: 10px;\n    padding: 8px;\n    background-color: var(--ezClockerWhite);\n    color: var(--ezClockerBlack);\n    font-size: var(--ezContentFontSize);\n    border-color: var(--ezClockerGray);\n    border-style: solid;\n    border-width: 1px;\n}\n\n.ezContainer-category-content-silver-border {\n    margin-left: 0;\n    margin-top: 10px;\n    margin-bottom: 10px;\n    margin-right: 10px;\n    padding: 8px;\n    background-color: rgba(224, 224, 224, 0.3);\n    color: var(--ezClockerBlack);\n    font-size: var(--ezContentFontSize);\n    border-color: var(--ezClockerSilver);\n    border-style: solid;\n    border-width: 1px;\n}\n\n.ezContainer_EmployeeCard {\n    padding: 4px;\n    margin: 4px;\n    background-color: var(--ezClockerNavy);\n    color: var(--ezClockerWhite);\n    border-style: solid;\n    border-width: 2px;\n    border-color: #032746;\n}\n\n.ezContainer-toolbutton {\n    display: contents;\n    padding-left: 4px;\n    padding-right: 4px;\n    background-color: transparent;\n}\n\n.ezContainer-archive-status {\n    display: grid;\n    padding: 2px;\n    grid-template-columns: auto auto;\n    grid-template-rows: 100%;\n    color: var(--ezClockerNavy);\n    font-size: 10pt;\n    align-content: center;\n    justify-content: end;\n    border-style: none;\n}\n\n.ezContainer-unarchive-status {\n    display: grid;\n    grid-template-columns: auto auto;\n    grid-template-rows: 100%;\n    padding: 2px;\n    background-color: transparent;\n    color: var(--ezClockerWhite);\n    font-size: 10pt;\n    align-content: center;\n    justify-content: end;\n    border-style: none;\n}\n\n.ezContainer-title-box-ezClockerYellow-pad4 {\n    padding: 4px;\n    background-color: var(--ezClockerYellow);\n    color: var(--ezClockerBlack);\n    border-color: var(--ezBorderYellow);\n    border-style: solid;\n    border-width: 1px;\n    border-radius: 0;\n    border-top-left-radius: 3px;\n    border-top-right-radius: 3px;\n}\n\n.ezContainer-title-box-ezClockerNavy-pad-4 {\n    padding: 4px;\n    background-color: var(--ezClockerNavy);\n    color: var(--ezClockerWhite);\n    font-weight: bold;\n    border-color: var(--ezBorderNavy);\n    border-style: solid;\n    border-width: 1px;\n    border-top-left-radius: 3px;\n    border-bottom-left-radius: 0;\n    border-top-right-radius: 3px;\n    border-bottom-right-radius: 0;\n}\n\n.ezContainer-title-box-ezClockerNavy-pad-8 {\n    padding: 8px;\n    background-color: var(--ezClockerNavy);\n    color: var(--ezClockerWhite);\n    font-weight: bold;\n    border-color: var(--ezBorderNavy);\n    border-style: solid;\n    border-width: 1px;\n    border-top-left-radius: 3px;\n    border-bottom-left-radius: 0;\n    border-top-right-radius: 3px;\n    border-bottom-right-radius: 0;\n}\n\n/* -------------------------------------------------------------------\n| Large Tablet Screen Styles (https://yesviz.com/laptops.php)       |\n------------------------------------------------------------------- */\n@media screen and (max-width: 1023px) {\n    .ezContainer-dialog-buttons-x2 {\n        display: grid;\n        margin-top: 20px;\n        justify-content: stretch;\n        align-content: center;\n        grid-template-rows: 100%;\n        grid-template-columns: auto auto;\n        grid-column-gap: 8px;\n        column-gap: 8px;\n    }\n}\n\n\n/* -------------------------------------------------------------------\n| Small Tablet Screen Styles (https://yesviz.com/tablets.php)       |\n------------------------------------------------------------------- */\n@media screen and (max-width: 768px) {\n    /*\n    .ezContainers_InputBox {\n        display: grid;\n        padding: 0;\n        grid-template-columns: 100%;\n        grid-template-rows: 50% 50%;\n        justify-content: start;\n        align-content: center;\n        background-color: transparent;\n        color: var(--ezFontColor);\n    }\n\n    .ezContaner_CenterInputBox {\n        display: grid;\n        padding: 0;\n        grid-template-columns: 100%;\n        grid-template-rows: auto auto;\n        justify-content: stretch;\n        align-content: center;\n        background-color: transparent;\n        color: var(--ezFontColor);\n    }\n\n    .ezContainer-dialog-buttons-x2 {\n        display: grid;\n        margin-top: 20px;\n        justify-content: stretch;\n        align-content: center;\n        grid-template-rows: 100%;\n        grid-template-columns: auto auto;\n        grid-column-gap: 8px;\n        column-gap: 8px;\n    }\n\n    .ezContainer_below-button-legal-disclaimer {\n        display: none;\n    }\n\n    .ezContainer_legal-disclaimer-small-screens {\n        display: grid;\n        justify-content: left;\n        align-content: left;\n        grid-template-rows: auto;\n        grid-template-columns: auto;\n    }\n\n    .ezContainer-link-footer {\n        display: grid;\n        margin-top: 20px;\n        justify-content: center;\n        align-content: center;\n        grid-template-columns: 50%;\n        grid-column-gap: 4px;\n    }\n    */\n}\n\n\n/* -------------------------------------------------------------------\n| Phone Screen Styles  (https://yesviz.com/mobiles.php)             |\n------------------------------------------------------------------- */\n@media screen and (max-width: 480px) {\n    .ezContainers_InputBox {\n        display: grid;\n        padding: 0;\n        grid-template-columns: 100%;\n        grid-template-rows: 50% 50%;\n        justify-content: start;\n        align-content: center;\n        background-color: transparent;\n        color: var(--ezFontColor);\n    }\n\n    .ezContaner_CenterInputBox {\n        display: grid;\n        padding: 0;\n        grid-template-columns: 100%;\n        grid-template-rows: auto auto;\n        justify-content: stretch;\n        align-content: center;\n        background-color: transparent;\n        color: var(--ezFontColor);\n    }\n\n    .ezContainer-dialog-buttons-x2 {\n        display: grid;\n        margin-top: 20px;\n        justify-content: stretch;\n        align-content: center;\n        grid-template-rows: 100%;\n        grid-template-columns: auto auto;\n        grid-column-gap: 8px;\n        column-gap: 8px;\n    }\n\n    .ezContainer_below-button-legal-disclaimer {\n        display: none;\n    }\n\n    .ezContainer_legal-disclaimer-small-screens {\n        display: grid;\n        justify-content: left;\n        align-content: left;\n        grid-template-rows: auto;\n        grid-template-columns: auto;\n    }\n\n    .ezContainer-legal-links {\n        display: grid;\n        grid-template-columns: auto;\n        grid-column-gap: 2px;\n        column-gap: 2px;\n        grid-row-gap: 0;\n        row-gap: 0;\n        justify-content: center;\n        align-content: center;\n        padding: 0;\n        margin-top: 2px;\n        background-color: var(--ezClockerWhite);\n        color: var(--ezContentFontColor);\n        font-family: var(--ezFontFamily);\n        font-size: var(--ezContentFontSize);\n        font-weight: var(--ezContentFontWeight);\n        font-style: var(--ezContentFontStyle);\n        border-style: none;\n    }\n\n    .ezContainer-link-footer {\n        display: grid;\n        margin-top: 20px;\n        justify-content: center;\n        align-content: center;\n        grid-template-columns: 50%;\n        grid-column-gap: 4px;\n    }\n}\n\n\n/* -------------------------------------------------------------------\n| Warable Screen Style  (https://yesviz.com/watches.php)            |\n------------------------------------------------------------------- */\n@media screen and (max-width: 319px) {\n    .ezContainers_InputBox {\n        display: grid;\n        padding: 0;\n        grid-template-columns: 100%;\n        grid-template-rows: 50% 50%;\n        justify-content: start;\n        align-content: center;\n        background-color: transparent;\n        color: var(--ezFontColor);\n    }\n\n    .ezContaner_CenterInputBox {\n        display: grid;\n        padding: 0;\n        grid-template-columns: 100%;\n        grid-template-rows: auto auto;\n        justify-content: stretch;\n        align-content: center;\n        background-color: transparent;\n        color: var(--ezFontColor);\n    }\n\n    .ezContainer-dialog-buttons-x2 {\n        display: grid;\n        margin-top: 8px;\n        justify-content: stretch;\n        align-content: center;\n        grid-template-rows: 100%;\n        grid-template-columns: auto auto;\n        grid-column-gap: 2px;\n        column-gap: 2px;\n    }\n\n    .ezContainer_below-button-legal-disclaimer {\n        display: none;\n    }\n\n    .ezContainer_legal-disclaimer-small-screens {\n        display: grid;\n        justify-content: left;\n        align-content: left;\n        grid-template-rows: auto;\n        grid-template-columns: auto;\n    }\n\n    .ezContainer-link-footer {\n        display: grid;\n        margin-top: 20px;\n        justify-content: center;\n        align-content: center;\n        grid-template-columns: 50%;\n        grid-column-gap: 4px;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
